<template>
	<div class="menuManagementList">
		<el-card class="location">
			<div class="divL">
				<el-button type="primary" @click="addPark">{{$t('lang.lab_addPark')}}</el-button>
				<el-button type="primary" @click="addGate">{{$t('lang.lab_addGate')}}</el-button>
				<el-button type="primary" @click="addCamera">添加车道</el-button>
				<el-button type="primary" @click="del">{{$t('lang.btn.deleteBtn')}}</el-button>
				<el-form :label-suffix="require('@/config/enum').c_colon" class="form-padding">
					<el-form-item :label="$t('lang.lab_keyword')">
						<!-- 关键词搜索 -->
						<el-input class="inputkey" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_keyword')"
							v-model="filterText" maxlength="20">
						</el-input>
					</el-form-item>
				</el-form>
				<el-tree class="filter-tree" ref="tree" :data="treeData" :props="defaultProps" :filter-node-method="filterNode"
					@node-click="handleNodeClick" default-expand-all :expand-on-click-node="false"></el-tree>
			</div>
			<div class="divR">
				<h3>{{this.title}}</h3><br /><br />
				<!-- 表单 -->
				<el-form :model="form" :rules="rule" ref="form" class="wid100" :label-width="require('@/config/enum').c_ws4"
					:label-suffix="require('@/config/enum').c_colon" v-if="this.isShowForm">
					<div v-if="this.type===1">
						<!-- 车场名称 -->
						<el-form-item :label="$t('lang.lab_parkName')" prop="parkName">
							<el-input v-model="form.parkName" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_parkName')"
								class="input-width" maxlength="50"></el-input>
						</el-form-item>
						<!-- 总车位数 -->
						<el-form-item :label="$t('lang.lab_carTtotalNum')" prop="totalNum">
							<el-input v-model.number="form.totalNum"
								:placeholder="$t('lang.lab_please_Input')+$t('lang.lab_carTtotalNum')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="固定车位数" prop="fixNum">
							<el-input v-model.number="form.fixNum"
								placeholder="请输入固定车位数" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
						<!-- 储值车位数 -->
						<el-form-item :label="$t('lang.lab_carStoreNum')" prop="storeNum">
							<el-input v-model.number="form.storeNum"
								:placeholder="$t('lang.lab_please_Input')+$t('lang.lab_carStoreNum')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
						<!-- 临时车位数 -->
						<el-form-item :label="$t('lang.lab_carTmpNum')" prop="tmpNum">
							<el-input v-model.number="form.tmpNum"
								:placeholder="$t('lang.lab_please_Input')+$t('lang.lab_carTmpNum')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>						
						<el-form-item label="新能源免费" prop="nePark">
							<el-radio-group v-model="form.nePark">
								<el-radio :label="1">{{$t('lang.lab_isAllow')}}</el-radio>
								<el-radio :label="0">{{$t('lang.lab_noAllow')}}</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="假车牌放行" prop="isFakePlate">
							<el-radio-group v-model="form.isFakePlate">
								<el-radio :label="1">放行</el-radio>
								<el-radio :label="0">拦截</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="车位数混合" prop="placeCountMix">
							<el-radio-group v-model="form.placeCountMix">
								<el-radio :label="1">{{$t('lang.lab_isAllow')}}</el-radio>
								<el-radio :label="0">{{$t('lang.lab_noAllow')}}</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="访客车辆进出" prop="guestCar">
							<el-radio-group v-model="form.guestCar">
								<el-radio :label="1">{{$t('lang.lab_isAllow')}}</el-radio>
								<el-radio :label="0">{{$t('lang.lab_noAllow')}}</el-radio>
							</el-radio-group>
						</el-form-item>
						<!--海康车场配置 -->
						<h3>海康车场配置</h3><br /><br />
						<el-form-item label="车场地址" prop="parkHost">
							<el-input v-model="form.parkHost" placeholder="请输入海康停车场地址" class="input-width" maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="车场key" prop="parkAppKey">
							<el-input v-model="form.parkAppKey" placeholder="请输入海康停车场key" class="input-width" maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="车场秘钥" prop="parkAppSecret">
							<el-input v-model="form.parkAppSecret" placeholder="请输入海康停车场秘钥" class="input-width" maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="车场Code" prop="parkCode">
							<el-input v-model="form.parkCode" placeholder="请输入海康停车场Code" class="input-width" maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="推送摄像头编号" prop="placeCountShow" v-if="1==2">
							<el-input v-model="form.placeCountShow" placeholder="请输入摄像头编号" class="input-width" maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="推送类型" prop="placeCountType" v-if="1==2">
							<el-radio-group v-model="form.placeCountType">
								<el-radio :label="1">储值车</el-radio>
								<el-radio :label="2">临时车</el-radio>
								<el-radio :label="0">关闭</el-radio>
							</el-radio-group>
						</el-form-item>
					</div>

					<div v-if="this.type===2">
						<!-- 出入口名称 -->
						<el-form-item :label="$t('lang.lab_gateName')" prop="gateName">
							<el-input v-model="form.gateName" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_gateName')"
								class="input-width" maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="海康标识" prop="gateCode">
							<el-input v-model="form.gateCode" placeholder="请输入海康出入口唯一标识"
								class="input-width" maxlength="50"></el-input>
						</el-form-item>
						<!-- 大小车场单选 -->
						<el-form-item :label="$t('lang.lab_parkType')" prop="parkType">
							<el-radio-group v-model="form.parkType">
								<el-radio :label="1">{{$t('lang.lab_bigPark')}}</el-radio>
								<el-radio :label="2">{{$t('lang.lab_smallPark')}}</el-radio>
							</el-radio-group>
						</el-form-item>
					</div>

					<div v-if="this.type===3">
						<!-- 出入口类型 -->
						<el-form-item label="车道类型" label-width="140px" prop="gateType">
							<el-radio-group v-model="form.gateType">
								<el-radio :label="1">{{$t('lang.lab_gateEntry')}}</el-radio>
								<el-radio :label="2">{{$t('lang.lab_gateExit')}}</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="海康车道标识" label-width="140px" prop="gateRoadwayCode" v-if="1==2">
							<el-input v-model="form.gateRoadwayCode" placeholder="请输入海康车道标识"
								class="input-width" maxlength="50"></el-input>
						</el-form-item>
						<!-- 摄像头编号 -->
						<el-form-item label="海康车道标识" label-width="140px" prop="cameraNum">
							<el-input v-model="form.cameraNum" placeholder="请输入海康车道标识"
								class="input-width" maxlength="50"></el-input>
						</el-form-item>
						<!-- 摄像头名称 -->
						<el-form-item label="车道名称" label-width="140px" prop="cameraName">
							<el-input v-model="form.cameraName" placeholder="请输入车道名称"
								class="input-width" maxlength="50"></el-input>
						</el-form-item>
						<!-- 摄像头类型 -->
						<el-form-item :label="$t('lang.lab_cameraType')" label-width="140px" prop="cameraType" v-if="1==2">
							<el-radio-group v-model="form.cameraType">
								<el-radio :label="1">{{$t('lang.lab_cameraMain')}}</el-radio>
								<el-radio :label="2">{{$t('lang.lab_cameraAuxiliary')}}</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="推送类型" label-width="140px" prop="pushType" v-if="1==2">
							<el-radio-group v-model="form.pushType">
								<el-radio :label="1">阿里云</el-radio>
								<el-radio :label="2">MQTT</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item :label="$t('lang.lab_screenType')" label-width="140px" prop="screenType" v-if="1==2">
							<el-radio-group v-model="form.screenType">
								<el-radio :label="1" v-if="this.form.pushType===1">{{$t('lang.lab_screen1')}}</el-radio>
								<el-radio :label="2">{{$t('lang.lab_screen2')}}</el-radio>
								<el-radio :label="3" v-if="this.form.pushType===1">{{$t('lang.lab_screen3')}}</el-radio>
								<el-radio :label="4" v-if="this.form.pushType===2">柏朗斯N</el-radio>
							</el-radio-group>
						</el-form-item>						
						<el-form-item :label="$t('lang.lab_kzsxtbh')" label-width="140px" prop="cameraNumOn" v-if="1==2">
							<el-input v-model="form.cameraNumOn" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_kzsxtbh')"
								class="input-width" maxlength="50"></el-input>
						</el-form-item>
						<!-- 摄像头地址 -->
						<el-form-item :label="$t('lang.lab_cameraUrl')" label-width="140px" v-if="1==2">
							<el-input v-model="form.cameraUrl" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_cameraUrl')"
								class="input-width" maxlength="50"></el-input>
						</el-form-item>
						<el-form-item :label="$t('lang.lab_cameraUrlLan')" label-width="140px" v-if="this.type===3 && 1==2">
							<el-input v-model="form.cameraUrlLan"
								:placeholder="$t('lang.lab_please_Input')+$t('lang.lab_cameraUrlLan')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
					</div>

					<!-- 车场规则 -->
					<el-button class="detailbtn" type="primary" @click="openParkRule('parkRuleForm')"
						v-if="this.type===1&&this.addOrEdit!=1">{{$t('lang.lab_ruleManage')}}</el-button>

					<!-- 月租车收费标准
					<el-button class="detailbtn" type="primary" @click="openMonthlyCost()"
						v-if="this.type===1&&this.addOrEdit!=1">{{$t('lang.lab_carMonthlyCost')}}</el-button> -->
					<!-- 车场支付规则 -->
					<el-button class="detailbtn" type="primary" @click="opencarWxpay('carWxpayForm')"
						v-if="this.type===1&&this.addOrEdit!=1">车场支付配置</el-button>
					<!-- 清空 -->
					<el-button class="btn-first" @click="clear()">{{$t('lang.btn_cancel')}}</el-button>
					<!-- 保存 -->
					<el-button class="detailbtn" type="primary" @click="save('form')" :disabled="isDisabled">
						{{$t('lang.btn_save')}}</el-button>
					<el-button class="detailbtn" type="primary" @click="openXspsz('form')" v-if="this.type == 3 && this.cameraId > 0 && this.form.screenType == 2 && 1==2">
						{{$t('lang.lab_xspsz')}}</el-button>
					<el-button class="detailbtn" type="primary" @click="openXspsz1('form')" v-if="1==2 && this.type == 3 && this.cameraId > 0 && (this.form.screenType == 3 || this.form.screenType == 4)">
						显示屏配置</el-button>
					<el-button class="detailbtn" type="primary" @click="yckz('form')" v-if="1==2 && this.type == 3 && this.cameraId > 0 && (this.form.screenType == 2 || this.form.screenType == 3 || this.form.screenType == 4)">远程控制</el-button>
					<el-button class="detailbtn" type="primary" @click="openSxtxx('form')" v-if="1==2 && this.type == 3 && this.cameraId > 0 && (this.form.screenType == 2 || this.form.screenType == 3 || this.form.screenType == 4)">摄像头信息</el-button>
					<el-button class="detailbtn" type="primary" @click="carTeam('form')" v-if="1==2 && this.type == 3 && this.cameraId > 0 && (this.form.screenType == 2 || this.form.screenType == 3 || this.form.screenType == 4)">车队模式</el-button>
				</el-form>
			</div>
		</el-card>

		<!-- 显示屏设置dialog -->
		<el-dialog :title="$t('lang.lab_xspsz')" width="60%" :visible.sync="xspszDialog"
			:close-on-click-modal='false'>
			<el-form :model="xspszForm" ref="xspszForm" class="wid100" :label-width="require('@/config/enum').c_ws9"
					:label-suffix="require('@/config/enum').c_colon">
					<el-form-item :label="$t('lang.lab_yinliang')" prop="yinliang">
							<el-input-number v-model="xspszForm.yinliang" :label="$t('lang.lab_please_Input') + $t('lang.lab_yinliang')"
								class="input-width" :min="1" :max="10"></el-input-number>&nbsp;&nbsp;
							<el-button class="detailbtn" type="primary" @click="ylSz('form')">
								{{$t('lang.lab_setBtn')}}</el-button>
					</el-form-item>
					<el-form-item :label="$t('lang.lab_sjtb')" prop="sjtb">
						<el-button class="detailbtn" type="primary" @click="tbSj('1')">同步系统时间</el-button>&nbsp;&nbsp;
						<el-date-picker v-model="xspszForm.timeSetByHand" type="datetime" placeholder='手工选择时间' align="right" value-format="timestamp" :picker-options="pickerOptions1" />&nbsp;&nbsp;
						<el-button class="detailbtn" type="primary" @click="tbSj('2')">
								{{$t('lang.lab_setBtn')}}</el-button>
					</el-form-item>
					<el-form-item label="行1广告" prop="hang1">
						<el-input v-model="xspszForm.hang1" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_hang1')" maxlength="50"
								class="input-width"></el-input>&nbsp;&nbsp;
						<el-button class="detailbtn" type="primary" @click="adSz('01')">
								{{$t('lang.lab_setBtn')}}</el-button>
					</el-form-item>
					<el-form-item label="行2广告" prop="hang2">
						<el-input v-model="xspszForm.hang2" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_hang2')" maxlength="50"
								class="input-width"></el-input>&nbsp;&nbsp;
						<el-button class="detailbtn" type="primary" @click="adSz('02')">
								{{$t('lang.lab_setBtn')}}</el-button>
					</el-form-item>
					<el-form-item label="行3广告" prop="hang3">
						<el-input v-model="xspszForm.hang3" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_hang3')" maxlength="50"
								class="input-width"></el-input>&nbsp;&nbsp;
						<el-button class="detailbtn" type="primary" @click="adSz('03')">
								{{$t('lang.lab_setBtn')}}</el-button>
					</el-form-item>
					<el-form-item label="行4广告" prop="hang4">
						<el-input v-model="xspszForm.hang4" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_hang4')" maxlength="50"
								class="input-width"></el-input>&nbsp;&nbsp;
						<el-button class="detailbtn" type="primary" @click="adSz('04')">
								{{$t('lang.lab_setBtn')}}</el-button>
					</el-form-item>
				</el-form>
		</el-dialog>
		<el-dialog :title="$t('lang.lab_xspsz')" width="60%" :visible.sync="xspszDialog1"
			:close-on-click-modal='false'>
			<el-form :model="xspszForm1" ref="xspszForm1" class="wid100" :label-width="require('@/config/enum').c_ws9"
					:label-suffix="require('@/config/enum').c_colon">
					<el-form-item :label="$t('lang.lab_yinliang')" prop="yinliang">
							<el-input-number v-model="xspszForm1.yinliang" :label="$t('lang.lab_please_Input') + $t('lang.lab_yinliang')"
								class="input-width" :min="10" :max="100"></el-input-number>&nbsp;&nbsp;
							<el-button class="detailbtn" type="primary" @click="ylSz1('form')">
								{{$t('lang.lab_setBtn')}}</el-button>
					</el-form-item>
					<el-form-item :label="$t('lang.lab_sjtb')" prop="sjtb">
						<el-button class="detailbtn" type="primary" @click="tbSj1('1')">同步系统时间</el-button>&nbsp;&nbsp;
						<el-date-picker v-model="xspszForm1.timeSetByHand" type="datetime" placeholder='手工选择时间' align="right" value-format="timestamp" :picker-options="pickerOptions1" />&nbsp;&nbsp;
						<el-button class="detailbtn" type="primary" @click="tbSj1('2')">
								{{$t('lang.lab_setBtn')}}</el-button>
					</el-form-item>
					<el-form-item label="行1广告" prop="hang1">
						<el-input v-model="xspszForm1.hang1" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_hang1')" maxlength="50"
								class="input-width"></el-input>&nbsp;&nbsp;
						<el-button class="detailbtn" type="primary" @click="adSz1('00')">
								{{$t('lang.lab_setBtn')}}</el-button>
					</el-form-item>
					<el-form-item label="行2广告" prop="hang2">
						<el-input v-model="xspszForm1.hang2" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_hang2')" maxlength="50"
								class="input-width"></el-input>&nbsp;&nbsp;
						<el-button class="detailbtn" type="primary" @click="adSz1('01')">
								{{$t('lang.lab_setBtn')}}</el-button>
					</el-form-item>
					<el-form-item label="行3广告" prop="hang3">
						<el-input v-model="xspszForm1.hang3" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_hang3')" maxlength="50"
								class="input-width"></el-input>&nbsp;&nbsp;
						<el-button class="detailbtn" type="primary" @click="adSz1('02')">
								{{$t('lang.lab_setBtn')}}</el-button>
					</el-form-item>
					<el-form-item label="行4广告" prop="hang4" v-if="this.form.screenType == 4">
						<el-input v-model="xspszForm1.hang4" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_hang4')" maxlength="50"
								class="input-width"></el-input>&nbsp;&nbsp;
						<el-button class="detailbtn" type="primary" @click="adSz1('03')">
								{{$t('lang.lab_setBtn')}}</el-button>
					</el-form-item>
					<el-form-item label="竖屏显示" prop="sjtb" v-if="this.form.screenType == 3">
						<el-button class="detailbtn" type="primary" @click="szsp()">设置竖屏</el-button>
					</el-form-item>
					<!--
					 <el-form-item label="行1广告" prop="hang1">
						<el-input v-model="xspszForm.hang1" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_hang1')" maxlength="50"
								class="input-width"></el-input>&nbsp;&nbsp;
						<el-button class="detailbtn" type="primary" @click="adSz('01')">
								{{$t('lang.lab_setBtn')}}</el-button>
					</el-form-item>
					<el-form-item label="行2广告" prop="hang2">
						<el-input v-model="xspszForm.hang2" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_hang2')" maxlength="50"
								class="input-width"></el-input>&nbsp;&nbsp;
						<el-button class="detailbtn" type="primary" @click="adSz('02')">
								{{$t('lang.lab_setBtn')}}</el-button>
					</el-form-item>
					<el-form-item label="行3广告" prop="hang3">
						<el-input v-model="xspszForm.hang3" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_hang3')" maxlength="50"
								class="input-width"></el-input>&nbsp;&nbsp;
						<el-button class="detailbtn" type="primary" @click="adSz('03')">
								{{$t('lang.lab_setBtn')}}</el-button>
					</el-form-item>
					<el-form-item label="行4广告" prop="hang4">
						<el-input v-model="xspszForm.hang4" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_hang4')" maxlength="50"
								class="input-width"></el-input>&nbsp;&nbsp;
						<el-button class="detailbtn" type="primary" @click="adSz('04')">
								{{$t('lang.lab_setBtn')}}</el-button>
					</el-form-item> -->
				</el-form>
		</el-dialog>
		<el-dialog title="摄像头信息" width="60%" :visible.sync="sxtxxDialog"
			:close-on-click-modal='false'>
			<el-form :model="sxtxxForm" ref="sxtxxForm" class="wid100" :label-width="require('@/config/enum').c_ws9"
					:label-suffix="require('@/config/enum').c_colon">
					<el-row>
						<el-col :span="12">
							<el-form-item label="名称">
							<span>{{ this.sxtxxForm.name }}</span>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item :label="$t('lang.resourStatus')">
								<span v-if="sxtxxForm.state === 0">在线</span>
								<span v-if="sxtxxForm.state === 1">离线</span>						
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="设备网卡IP">
							<span>{{ this.sxtxxForm.local_ip }}</span>
							</el-form-item>
						</el-col>						
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="上次离线时间">
							<span>{{ this.sxtxxForm.last_offline_time*1000 | time}}</span>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="上次上线时间">
							<span>{{ this.sxtxxForm.last_online_time*1000 | time }}</span>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
		</el-dialog>
		<el-dialog title="车队模式" width="60%" :visible.sync="carTeamDialog"
			:close-on-click-modal='false'>
			<el-form :model="carTeamForm" ref="sxtxxForm" class="wid100" :label-width="require('@/config/enum').c_ws9"
					:label-suffix="require('@/config/enum').c_colon">
				<el-form-item label="状态" prop="state">
							<el-radio-group v-model="carTeamForm.state">
								<el-radio :label="0">解锁</el-radio>
								<el-radio :label="1">高电平锁定</el-radio>
							</el-radio-group>
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							<el-button class="detailbtn" type="primary" @click="carTeamSet()">
								设置车队模式</el-button>
						</el-form-item>

			</el-form>
		</el-dialog>
		<!-- 车场支付配置 -->
		<el-dialog title="车场支付配置" width="30%" :visible.sync="carWxpayDialog"  append-to-body>
			<el-form :model="carWxpayForm" :rules="carWxpayRule" ref="carWxpayForm" :label-width="require('@/config/enum').c_ws3"
					:label-suffix="require('@/config/enum').c_colon">
					<h3 style="text-align: center;">微信支付</h3><br/>
					<el-form-item label="APPID" prop="appId">
						<el-input v-model="carWxpayForm.appId" placeholder="请输入APPID" maxlength="50"
								class="input-width"></el-input>
					</el-form-item>
					<el-form-item label="商户号" prop="mchId">
						<el-input v-model="carWxpayForm.mchId" placeholder="请输入商户号" maxlength="50"
								class="input-width"></el-input>
					</el-form-item>
					<el-form-item label="API秘钥" prop="mchKey">
						<el-input v-model="carWxpayForm.mchKey" placeholder="请输入API秘钥" maxlength="50"
								class="input-width"></el-input>
					</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
					<el-button @click="carWxpayDialog = false">{{$t('lang.btn_backpage')}}</el-button>
					<el-button type="primary" @click="saveCarWxpay('carWxpayForm')">{{$t('lang.btn_save')}}</el-button>
				</div>
		</el-dialog>
		<!-- 车场规则dialog -->
		<el-dialog :title="$t('lang.lab_ruleManage')" width="60%" :visible.sync="parkRuleDialog"
			:close-on-click-modal='false'>
			<el-form :model="parkRuleForm" class="wid100" :label-width="require('@/config/enum').c_ws4"
				:label-suffix="require('@/config/enum').c_colon">
				<div class="divDialogL">
					<h3 style="text-align: center;">{{$t('lang.lab_monthlyRent')}}</h3>
					<!-- 重复入场 -->
					<el-form-item :label="$t('lang.lab_isRepeat')">
						<el-radio-group v-model="parkRuleForm.isRepeat">
							<el-radio :label="1">{{$t('lang.lab_isAllow')}}</el-radio>
							<el-radio :label="0">{{$t('lang.lab_noAllow')}}</el-radio>
						</el-radio-group>&#12288;
						<el-tooltip class="item" effect="light" placement="right">
							<div slot="content">
							<span
								style="font-size:14px">已在场内车辆再次入场是否自动抬杆</span>
							</div>
							<i class="el-icon-warning xjbzTips"></i>
						</el-tooltip>
					</el-form-item>
					<!-- 一位多车 -->
					<el-form-item :label="$t('lang.lab_moreCar')">
						<el-radio-group v-model="parkRuleForm.moreCar">
							<el-radio :label="1">{{$t('lang.lab_ycrc')}}</el-radio>
							<el-radio :label="0">{{$t('lang.lab_jjrc')}}</el-radio>
							<el-radio :label="2">{{$t('lang.lab_zlsrc')}}</el-radio>
						</el-radio-group>&#12288;
						<el-tooltip class="item" effect="light" placement="right">
							<div slot="content">
							<span
								style="font-size:14px">进场车辆是否允许超过拥有的车位数</span>
							</div>
							<i class="el-icon-warning xjbzTips"></i>
						</el-tooltip>
					</el-form-item>
					<!-- 无入场放行 -->
					<el-form-item :label="$t('lang.lab_noInOut')">
						<el-radio-group v-model="parkRuleForm.noInOut">
							<el-radio :label="1">{{$t('lang.lab_isAllow')}}</el-radio>
							<el-radio :label="0">{{$t('lang.lab_noAllow')}}</el-radio>
						</el-radio-group>&#12288;
						<el-tooltip class="item" effect="light" placement="right">
							<div slot="content">
							<span
								style="font-size:14px">无入场记录车辆出场是否自动抬杆</span>
							</div>
							<i class="el-icon-warning xjbzTips"></i>
						</el-tooltip>
					</el-form-item>
					<!-- 车位满放行 -->
					<el-form-item :label="$t('lang.lab_fullOut')">
						<el-radio-group v-model="parkRuleForm.fullOut">
							<el-radio :label="1">{{$t('lang.lab_isAllow')}}</el-radio>
							<el-radio :label="0">{{$t('lang.lab_noAllow')}}</el-radio>
						</el-radio-group>&#12288;
						<el-tooltip class="item" effect="light" placement="right">
							<div slot="content">
							<span
								style="font-size:14px">停车场内总车位已满是否自动抬杆</span>
							</div>
							<i class="el-icon-warning xjbzTips"></i>
						</el-tooltip>
					</el-form-item>
					<!-- 剩余有效提醒天数 -->
					<el-form-item :label="$t('lang.lab_validDay')">
						<el-input-number v-model="parkRuleForm.validDay" size="small" controls-position="right" :min="1" :max="999">
						</el-input-number>
					</el-form-item>
					<!-- 月租车收费标准 -->
					<el-form-item :label="$t('lang.lab_carMonthlyCost')" v-if="1==2">
						<el-select class="aaa" v-model="parkRuleForm.monthlyCost">
							<el-option v-for="(item,index) in monthlyCosts" :key="index" :label="item.costName" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<h3 style="text-align: center;">固定车</h3>
					<!-- 重复入场 -->
					<el-form-item :label="$t('lang.lab_isRepeat')">
						<el-radio-group v-model="parkRuleForm.fixIsRepeat">
							<el-radio :label="1">{{$t('lang.lab_isAllow')}}</el-radio>
							<el-radio :label="0">{{$t('lang.lab_noAllow')}}</el-radio>
						</el-radio-group>&#12288;
						<el-tooltip class="item" effect="light" placement="right">
							<div slot="content">
							<span
								style="font-size:14px">已在场内车辆再次入场是否自动抬杆</span>
							</div>
							<i class="el-icon-warning xjbzTips"></i>
						</el-tooltip>
					</el-form-item>
					<!-- 一位多车 -->
					<el-form-item :label="$t('lang.lab_moreCar')">
						<el-radio-group v-model="parkRuleForm.fixMoreCar">
							<el-radio :label="1">{{$t('lang.lab_ycrc')}}</el-radio>
							<el-radio :label="0">{{$t('lang.lab_jjrc')}}</el-radio>
							<el-radio :label="2">{{$t('lang.lab_zlsrc')}}</el-radio>
						</el-radio-group>&#12288;
						<el-tooltip class="item" effect="light" placement="right">
							<div slot="content">
							<span
								style="font-size:14px">进场车辆是否允许超过拥有的车位数</span>
							</div>
							<i class="el-icon-warning xjbzTips"></i>
						</el-tooltip>
					</el-form-item>
					<!-- 无入场放行 -->
					<el-form-item :label="$t('lang.lab_noInOut')">
						<el-radio-group v-model="parkRuleForm.fixNoInOut">
							<el-radio :label="1">{{$t('lang.lab_isAllow')}}</el-radio>
							<el-radio :label="0">{{$t('lang.lab_noAllow')}}</el-radio>
						</el-radio-group>&#12288;
						<el-tooltip class="item" effect="light" placement="right">
							<div slot="content">
							<span
								style="font-size:14px">无入场记录车辆出场是否自动抬杆</span>
							</div>
							<i class="el-icon-warning xjbzTips"></i>
						</el-tooltip>
					</el-form-item>
					<!-- 车位满放行 -->
					<el-form-item :label="$t('lang.lab_fullOut')">
						<el-radio-group v-model="parkRuleForm.fixFullOut">
							<el-radio :label="1">{{$t('lang.lab_isAllow')}}</el-radio>
							<el-radio :label="0">{{$t('lang.lab_noAllow')}}</el-radio>
						</el-radio-group>&#12288;
						<el-tooltip class="item" effect="light" placement="right">
							<div slot="content">
							<span
								style="font-size:14px">停车场内总车位已满是否自动抬杆</span>
							</div>
							<i class="el-icon-warning xjbzTips"></i>
						</el-tooltip>
					</el-form-item>
					<!-- 剩余有效提醒天数 -->
					<el-form-item :label="$t('lang.lab_validDay')">
						<el-input-number v-model="parkRuleForm.fixValidDay" size="small" controls-position="right" :min="1" :max="999">
						</el-input-number>
					</el-form-item>
					<h3 style="text-align: center;">储值车</h3>
					<!-- 重复入场 -->
					<el-form-item :label="$t('lang.lab_isRepeat')">
						<el-radio-group v-model="parkRuleForm.storeIsRepeat">
							<el-radio :label="1">{{$t('lang.lab_isAllow')}}</el-radio>
							<el-radio :label="0">{{$t('lang.lab_noAllow')}}</el-radio>
						</el-radio-group>&#12288;
						<el-tooltip class="item" effect="light" placement="right">
							<div slot="content">
							<span
								style="font-size:14px">已在场内车辆再次入场是否自动抬杆</span>
							</div>
							<i class="el-icon-warning xjbzTips"></i>
						</el-tooltip>
					</el-form-item>
					<!-- 无入场放行 -->
					<el-form-item :label="$t('lang.lab_noInOut')">
						<el-radio-group v-model="parkRuleForm.storeNoInOut">
							<el-radio :label="1">{{$t('lang.lab_isAllow')}}</el-radio>
							<el-radio :label="0">{{$t('lang.lab_noAllow')}}</el-radio>
						</el-radio-group>&#12288;
						<el-tooltip class="item" effect="light" placement="right">
							<div slot="content">
							<span
								style="font-size:14px">无入场记录车辆出场是否自动抬杆</span>
							</div>
							<i class="el-icon-warning xjbzTips"></i>
						</el-tooltip>
					</el-form-item>
					<!-- 车位满放行 -->
					<el-form-item :label="$t('lang.lab_fullOut')">
						<el-radio-group v-model="parkRuleForm.storeFullOut">
							<el-radio :label="1">{{$t('lang.lab_isAllow')}}</el-radio>
							<el-radio :label="0">{{$t('lang.lab_noAllow')}}</el-radio>
						</el-radio-group>&#12288;
						<el-tooltip class="item" effect="light" placement="right">
							<div slot="content">
							<span
								style="font-size:14px">停车场内总车位已满是否自动抬杆</span>
							</div>
							<i class="el-icon-warning xjbzTips"></i>
						</el-tooltip>
					</el-form-item>
					<!-- 出入口验证 -->
					<el-form-item label="出入口验证">
						<el-radio-group v-model="parkRuleForm.checkGate">
							<el-radio :label="1">{{$t('lang.lab_isAllow')}}</el-radio>
							<el-radio :label="0">{{$t('lang.lab_noAllow')}}</el-radio>
						</el-radio-group>&#12288;
						<el-tooltip class="item" effect="light" placement="right">
							<div slot="content">
							<span
								style="font-size:14px">开启出入口验证需要车辆在“车辆发卡”配置出入口才可放行</span>
							</div>
							<i class="el-icon-warning xjbzTips"></i>
						</el-tooltip>
					</el-form-item>
					<!-- 余位推送 -->
					<el-form-item label="屏幕余位推送">
						<el-radio-group v-model="parkRuleForm.stroeNoUseCount">
							<el-radio :label="1">开启-余位数量</el-radio>
							<el-radio :label="2">开启-入场数量</el-radio>
							<el-radio :label="0">{{$t('lang.lab_noAllow')}}</el-radio>
						</el-radio-group>&#12288;
						<el-tooltip class="item" effect="light" placement="right">
							<div slot="content">
							<span
								style="font-size:14px">开启余位推送会将车位剩余数量或车辆入场数量推送至车场入口显示屏，支持柏朗斯显示屏，推送至显示屏第四行</span>
							</div>
							<i class="el-icon-warning xjbzTips"></i>
						</el-tooltip>
					</el-form-item>
					<!-- 标准规则 -->
					<el-form-item :label="$t('lang.lab_temppayStandard')">
						<template>
							<el-select class="aaa" v-model="parkRuleForm.storePayStandard">
								<el-option v-for="item in optionsCarStore" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>&nbsp;&nbsp;
							<el-button @click="changeStoreCount()">{{$t('lang.trialDetailBtn')}}</el-button>
						</template>
					</el-form-item>
				</div>

				<div class="divDialogR">
					<h3 style="text-align: center;">{{$t('lang.lab_temporary')}}</h3>
					<!-- 临时车规则 -->
					<el-form-item :label="$t('lang.lab_temporaryCar')">
						<el-radio-group v-model="parkRuleForm.temporaryCar">
							<el-radio :label="1">{{$t('lang.lab_isAllow')}}</el-radio>
							<el-radio :label="0">{{$t('lang.lab_noAllow')}}</el-radio>
						</el-radio-group>
					</el-form-item>
					<div v-if="parkRuleForm.temporaryCar===1">
						<!-- 重复入场 -->
						<el-form-item :label="$t('lang.lab_isRepeat')">
							<el-radio-group v-model="parkRuleForm.tempIsRepeat">
								<el-radio :label="1">{{$t('lang.lab_isAllow')}}</el-radio>
								<el-radio :label="0">{{$t('lang.lab_noAllow')}}</el-radio>
							</el-radio-group>&#12288;
							<el-tooltip class="item" effect="light" placement="right">
								<div slot="content">
								<span
									style="font-size:14px">已在场内车辆再次入场是否自动抬杆</span>
								</div>
								<i class="el-icon-warning xjbzTips"></i>
							</el-tooltip>
						</el-form-item>
						<!-- 访客临时车 -->
						<el-form-item label="屏幕余位推送">
							<el-radio-group v-model="parkRuleForm.visitorTemporaryCar">
								<el-radio :label="1">{{$t('lang.lab_isAllow')}}</el-radio>
								<el-radio :label="0">{{$t('lang.lab_noAllow')}}</el-radio>
							</el-radio-group>&#12288;
							<el-tooltip class="item" effect="light" placement="right">
								<div slot="content">
								<span
									style="font-size:14px">显示屏上显示临时车剩余车位</span>
								</div>
								<i class="el-icon-warning xjbzTips"></i>
							</el-tooltip>
						</el-form-item>
						<!-- 人工确认临时车 -->
						<el-form-item :label="$t('lang.lab_confirmTemporaryCar')">
							<el-radio-group v-model="parkRuleForm.confirmTemporaryCar">
								<el-radio :label="1">{{$t('lang.lab_isAllow')}}</el-radio>
								<el-radio :label="0">{{$t('lang.lab_noAllow')}}</el-radio>
							</el-radio-group>&#12288;
							<el-tooltip class="item" effect="light" placement="right">
								<div slot="content">
								<span
									style="font-size:14px">临时车需要人工确认才可以入场</span>
								</div>
								<i class="el-icon-warning xjbzTips"></i>
							</el-tooltip>
						</el-form-item>
						<!-- 车位满放行 -->
						<el-form-item :label="$t('lang.lab_fullOut')">
							<el-radio-group v-model="parkRuleForm.tempFullIn">
								<el-radio :label="1">{{$t('lang.lab_isAllow')}}</el-radio>
								<el-radio :label="0">{{$t('lang.lab_noAllow')}}</el-radio>
							</el-radio-group>&#12288;
							<el-tooltip class="item" effect="light" placement="right">
								<div slot="content">
								<span
									style="font-size:14px">停车场内总车位已满是否自动抬杆</span>
								</div>
								<i class="el-icon-warning xjbzTips"></i>
							</el-tooltip>
						</el-form-item>
						<!-- 临时车入小车场 -->
						<el-form-item :label="$t('lang.lab_tempInSmallPark')">
							<el-radio-group v-model="parkRuleForm.tempInSmallPark">
								<el-radio :label="1">{{$t('lang.lab_isAllow')}}</el-radio>
								<el-radio :label="0">{{$t('lang.lab_noAllow')}}</el-radio>
							</el-radio-group>
						</el-form-item>
						<!-- 无入场放行 -->
						<el-form-item :label="$t('lang.lab_tempNoInOut')">
							<el-radio-group v-model="parkRuleForm.tempNoInOut">
								<el-radio :label="1">{{$t('lang.lab_isAllow')}}</el-radio>
								<el-radio :label="0">{{$t('lang.lab_noAllow')}}</el-radio>
							</el-radio-group>&#12288;
							<el-tooltip class="item" effect="light" placement="right">
								<div slot="content">
								<span
									style="font-size:14px">无入场记录车辆出场是否自动抬杆</span>
								</div>
								<i class="el-icon-warning xjbzTips"></i>
							</el-tooltip>
						</el-form-item>
						<!-- 出入口验证 -->
						<el-form-item label="出入口验证">
							<el-radio-group v-model="parkRuleForm.tempCheckGate">
								<el-radio :label="1">{{$t('lang.lab_isAllow')}}</el-radio>
								<el-radio :label="0">{{$t('lang.lab_noAllow')}}</el-radio>
							</el-radio-group>&#12288;
							<el-tooltip class="item" effect="light" placement="right">
								<div slot="content">
								<span
									style="font-size:14px">开启后临时车只有通过授权的入口入场</span>
								</div>
								<i class="el-icon-warning xjbzTips"></i>
							</el-tooltip>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							<el-button @click="changeTempCheckGate()">出入口</el-button>
						</el-form-item>
						<el-form-item label="允入车牌类型">
							<el-radio-group v-model="parkRuleForm.allowInNum">
								<el-radio :label="1">蓝牌</el-radio>
								<el-radio :label="2">绿牌</el-radio>
								<el-radio :label="0">所有车牌</el-radio>
							</el-radio-group>&#12288;
							<el-tooltip class="item" effect="light" placement="right">
								<div slot="content">
								<span
									style="font-size:14px">允许临时车进入的车牌类型</span>
								</div>
								<i class="el-icon-warning xjbzTips"></i>
							</el-tooltip>
						</el-form-item>
						<el-form-item :label="$t('lang.lab_temppayStandard')">
							<template>
								<el-select class="aaa" v-model="parkRuleForm.temppayStandard">
									<el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>&nbsp;&nbsp;
								<el-button @click="changeCostHour()">{{$t('lang.trialDetailBtn')}}</el-button>
							</template>
						</el-form-item>
						<el-form-item :label="$t('lang.lab_temppayStandardDiscount')">
							<template>
								<el-select class="aaa" v-model="parkRuleForm.temppayStandardDiscount">
									<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>&nbsp;&nbsp;
								<el-button @click="changeCostHourDiscount()">{{$t('lang.trialDetailBtn')}}</el-button>
							</template>
						</el-form-item>
						<!-- 商家停车减免 -->
						<el-form-item :label="$t('lang.lab_temppayStandardDerate')">
							<template>
								<el-select class="aaa" v-model="parkRuleForm.temppayStandardDerate">
									<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>&nbsp;&nbsp;
								<el-button @click="changeCostHourDerate()">{{$t('lang.trialDetailBtn')}}</el-button>
							</template>
						</el-form-item>
						<!-- 定时开启 -->
						<el-form-item label="定时开启">
							<el-radio-group v-model="parkRuleForm.tempTiming">
								<el-radio :label="1">{{$t('lang.lab_isAllow')}}</el-radio>
								<el-radio :label="0">{{$t('lang.lab_noAllow')}}</el-radio>
							</el-radio-group>&#12288;
							<el-tooltip class="item" effect="light" placement="right">
								<div slot="content">
								<span
									style="font-size:14px">临时车在固定时间段开启，其余时间段不允许入场。</span>
								</div>
								<i class="el-icon-warning xjbzTips"></i>								
							</el-tooltip>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							<el-button @click="changeTiming()">{{$t('lang.trialDetailBtn')}}</el-button>
						</el-form-item>
						<el-form-item label="新能源车辆">
							<el-radio-group v-model="parkRuleForm.nePark">
								<el-radio :label="1">新能源规则</el-radio>
								<el-radio :label="0">标准规则</el-radio>
							</el-radio-group>&#12288;
							<el-tooltip class="item" effect="light" placement="right">
								<div slot="content">
								<span
									style="font-size:14px">新能源车辆按照特殊新能源规则计费</span>
								</div>
								<i class="el-icon-warning xjbzTips"></i>
							</el-tooltip>
						</el-form-item>
						<el-form-item :label="$t('lang.lab_temppayStandardGzh')">
							<template>
								<el-select class="aaa" v-model="parkRuleForm.temppayStandardGzh">
									<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>&nbsp;&nbsp;
								<el-button @click="changeCostHourGzh()">{{$t('lang.trialDetailBtn')}}</el-button>
							</template>
						</el-form-item>						
					</div>
				</div>
			</el-form>
			<el-dialog width="50%" :title="$t('lang.trialDetailBtn')" :visible.sync="innerCostHour" append-to-body>
				<el-form :model="costHourForm" :rules="costHourRule" ref="costHourForm" class="wid100" :label-width="require('@/config/enum').c_ws9"
					:label-suffix="require('@/config/enum').c_colon">
					<el-form-item :label="$t('lang.lab_costName')" prop="costName">
							<el-input v-model="costHourForm.costName" :placeholder="$t('lang.lab_please_Input')"
								class="input-width" maxlength="50"></el-input>
					</el-form-item>
					<el-form-item label="免费时长(分钟)" prop="cost1">
							<el-input v-model.number="costHourForm.cost1"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="收费标准(元/小时)" prop="cost2">
							<el-input v-model.number="costHourForm.cost2"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="是否上限" prop="cost3">
							<el-radio v-model="costHourForm.cost3" :label=1>{{$t('lang.lab_isYes')}}</el-radio>
							<el-radio v-model="costHourForm.cost3" :label=0>{{$t('lang.lab_isNo')}}</el-radio>
						</el-form-item>
						<!--<el-form-item label="cost3" prop="cost3">
							<el-input v-model.number="costHourForm.cost3"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>-->
						<el-form-item label="收费上限(元/天)" prop="cost4" v-if="this.costHourForm.cost3  === 1">
							<el-input v-model.number="costHourForm.cost4"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="缴费后离场时间(分钟)" prop="cost5">
							<el-input v-model.number="costHourForm.cost5"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="时长减免(分钟)" prop="cost6">
							<el-input v-model.number="costHourForm.cost6"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="初始金额(元)" prop="cost7">
							<el-input v-model.number="costHourForm.cost7"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="innerCostHour = false">{{$t('lang.btn_backpage')}}</el-button>
					<el-button type="primary" @click="saveCostHour('costHourForm')">{{$t('lang.btn_save')}}</el-button>
				</div>
			</el-dialog>
			<el-dialog width="50%" :title="$t('lang.trialDetailBtn')" :visible.sync="innerCostCount" append-to-body>
				<el-form :model="costCountForm" :rules="costCountRule" ref="costCountForm" class="wid100" :label-width="require('@/config/enum').c_ws9"
					:label-suffix="require('@/config/enum').c_colon">
					<el-form-item :label="$t('lang.lab_costName')" prop="costName">
							<el-input v-model="costCountForm.costName" :placeholder="$t('lang.lab_please_Input')"
								class="input-width" maxlength="50"></el-input>
					</el-form-item>
					<el-form-item label="免费时长(分钟)" prop="cost1">
							<el-input v-model.number="costCountForm.cost1"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="收费标准(元/次)" prop="cost2">
							<el-input v-model.number="costCountForm.cost2"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
						
						<el-form-item label="缴费后离场时间(分钟)" prop="cost5">
							<el-input v-model.number="costCountForm.cost5"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="innerCostCount = false">{{$t('lang.btn_backpage')}}</el-button>
					<el-button type="primary" @click="saveCostCount('costCountForm')">{{$t('lang.btn_save')}}</el-button>
				</div>
			</el-dialog>
			<el-dialog width="50%" :title="$t('lang.trialDetailBtn')" :visible.sync="innerStoreCostHour" append-to-body>
				<el-form :model="storeCostHourForm" :rules="storeCostHourRule" ref="storeCostHourForm" class="wid100" :label-width="require('@/config/enum').c_ws9"
					:label-suffix="require('@/config/enum').c_colon">
					<el-form-item :label="$t('lang.lab_costName')" prop="costName">
							<el-input v-model="storeCostHourForm.costName" :placeholder="$t('lang.lab_please_Input')"
								class="input-width" maxlength="50"></el-input>
					</el-form-item>
					<el-form-item label="每日减免(分钟)" prop="cost1">
							<el-input v-model.number="storeCostHourForm.cost1"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="收费标准(元/小时)" prop="cost2">
							<el-input v-model.number="storeCostHourForm.cost2"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="是否上限" prop="cost3">
							<el-radio v-model="storeCostHourForm.cost3" :label=1>{{$t('lang.lab_isYes')}}</el-radio>
							<el-radio v-model="storeCostHourForm.cost3" :label=0>{{$t('lang.lab_isNo')}}</el-radio>
						</el-form-item>
						<!--<el-form-item label="cost3" prop="cost3">
							<el-input v-model.number="costHourForm.cost3"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>-->
						<el-form-item label="收费上限(元/天)" prop="cost4" v-if="this.storeCostHourForm.cost3  === 1">
							<el-input v-model.number="storeCostHourForm.cost4"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="缴费后离场时间(分钟)" prop="cost5">
							<el-input v-model.number="storeCostHourForm.cost5"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="innerStoreCostHour = false">{{$t('lang.btn_backpage')}}</el-button>
					<el-button type="primary" @click="saveStoreCostHour('storeCostHourForm')">{{$t('lang.btn_save')}}</el-button>
				</div>
			</el-dialog>
			<el-dialog width="50%" :title="$t('lang.trialDetailBtn')" :visible.sync="innerStoreCount" append-to-body>
				<el-form :model="storeCountForm" :rules="storeCountRule" ref="storeCountForm" class="wid100" :label-width="require('@/config/enum').c_ws9"
					:label-suffix="require('@/config/enum').c_colon">
					<el-form-item :label="$t('lang.lab_costName')" prop="costName">
							<el-input v-model="storeCountForm.costName" :placeholder="$t('lang.lab_please_Input')"
								class="input-width" maxlength="50"></el-input>
					</el-form-item>
					<el-form-item label="免费时长(分钟)" prop="cost2">
							<el-input v-model.number="storeCountForm.cost2"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
					<el-form-item label="收费标准(元/天)" prop="cost1">
							<el-input v-model="storeCountForm.cost1"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button type="primary" @click="saveStoreCount('storeCountForm')">{{$t('lang.btn_save')}}</el-button>
				</div>
			</el-dialog>
			<el-dialog width="50%" :title="$t('lang.trialDetailBtn')" :visible.sync="innerCostHourDiscount" append-to-body>
				<el-form :model="costHourDiscountForm" :rules="costHourDiscountRule" ref="costHourDiscountForm" class="wid100" :label-width="require('@/config/enum').c_ws9"
					:label-suffix="require('@/config/enum').c_colon">
					<el-form-item :label="$t('lang.lab_costName')" prop="costName">
							<el-input v-model="costHourDiscountForm.costName" :placeholder="$t('lang.lab_please_Input')"
								class="input-width" maxlength="50"></el-input>
					</el-form-item>
					<el-form-item label="免费时长(分钟)" prop="cost1">
							<el-input v-model.number="costHourDiscountForm.cost1"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="收费标准(元/小时)" prop="cost2">
							<el-input v-model.number="costHourDiscountForm.cost2"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="是否上限" prop="cost3">
							<el-radio v-model="costHourDiscountForm.cost3" :label=1>{{$t('lang.lab_isYes')}}</el-radio>
							<el-radio v-model="costHourDiscountForm.cost3" :label=0>{{$t('lang.lab_isNo')}}</el-radio>
						</el-form-item>
						<!--<el-form-item label="cost3" prop="cost3">
							<el-input v-model.number="costHourForm.cost3"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>-->
						<el-form-item label="收费上限(元/天)" prop="cost4" v-if="this.costHourDiscountForm.cost3  === 1">
							<el-input v-model.number="costHourDiscountForm.cost4"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="缴费后离场时间(分钟)" prop="cost5">
							<el-input v-model.number="costHourDiscountForm.cost5"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="innerCostHourDiscount = false">{{$t('lang.btn_backpage')}}</el-button>
					<el-button type="primary" @click="saveCostHourDiscount('costHourDiscountForm')">{{$t('lang.btn_save')}}</el-button>
				</div>
			</el-dialog>
			<el-dialog width="50%" :title="$t('lang.trialDetailBtn')" :visible.sync="innerCostHourDerate" append-to-body>
				<el-form :model="costHourDerateForm" :rules="costHourDerateRule" ref="costHourDerateForm" class="wid100" :label-width="require('@/config/enum').c_ws9"
					:label-suffix="require('@/config/enum').c_colon">
					<el-row>
						<el-col :span = '30'>
							<el-form-item label="查找商户" prop="keyword">
								<el-input v-model="costHourDerateForm.keyword" placeholder="请输入手机号或商户名" class="input-width" maxlength="50"></el-input>
							</el-form-item>		
						</el-col>
						<el-col :span = '5'>
							&nbsp;&nbsp;&nbsp;&nbsp;<el-button type="primary" @click="searchStaff()">查询</el-button>	
						</el-col>
					</el-row>
					<el-form-item label="商户ID" prop="adminId">
						<el-input v-model="costHourDerateForm.adminId" class="input-width" maxlength="50" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="商户名" prop="adminName">
						<el-input v-model="costHourDerateForm.adminName" class="input-width" maxlength="50" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="本月已使用额度" prop="isUseCountMonth">
						<el-input v-model="costHourDerateForm.isUseCountMonth" class="input-width" maxlength="50" :disabled="true"></el-input>
					</el-form-item>						
					<el-form-item :label="$t('lang.lab_costName')" prop="costName">
							<el-input v-model="costHourDerateForm.costName" :placeholder="$t('lang.lab_please_Input')"
								class="input-width" maxlength="50"></el-input>
					</el-form-item>
					<el-form-item label="免费时长(分钟)" prop="cost1">
							<el-input v-model.number="costHourDerateForm.cost1"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="收费标准(元/小时)" prop="cost2">
							<el-input v-model.number="costHourDerateForm.cost2"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="是否上限" prop="cost3">
							<el-radio v-model="costHourDerateForm.cost3" :label=1>{{$t('lang.lab_isYes')}}</el-radio>
							<el-radio v-model="costHourDerateForm.cost3" :label=0>{{$t('lang.lab_isNo')}}</el-radio>
						</el-form-item>
						<!--<el-form-item label="cost3" prop="cost3">
							<el-input v-model.number="costHourForm.cost3"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>-->
						<el-form-item label="收费上限(元/天)" prop="cost4" v-if="this.costHourDerateForm.cost3  === 1">
							<el-input v-model.number="costHourDerateForm.cost4"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="缴费后离场时间(分钟)" prop="cost5">
							<el-input v-model.number="costHourDerateForm.cost5"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="订单减免时长(分钟)" prop="cost6">
							<el-input v-model.number="costHourDerateForm.cost6"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="月减免上限(次)" prop="cost7">
							<el-input v-model.number="costHourDerateForm.cost7"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="innerCostHourDerate = false">{{$t('lang.btn_backpage')}}</el-button>
					<el-button type="primary" @click="saveCostHourDerate('costHourDerateForm')">{{$t('lang.btn_save')}}</el-button>
				</div>
			</el-dialog>
			<el-dialog width="50%" :title="$t('lang.trialDetailBtn')" :visible.sync="innerCostHourGzh" append-to-body>
				<el-form :model="costHourGzhForm" :rules="costHourGzhRule" ref="costHourGzhForm" class="wid100" :label-width="require('@/config/enum').c_ws12"
					:label-suffix="require('@/config/enum').c_colon">
					<el-form-item :label="$t('lang.lab_costName')" prop="costName">
							<el-input v-model="costHourGzhForm.costName" :placeholder="$t('lang.lab_please_Input')"
								class="input-width" maxlength="50"></el-input>
					</el-form-item>
					<el-form-item label="免费时长(分钟)" prop="cost1">
							<el-input v-model.number="costHourGzhForm.cost1"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="订单减免时长(分钟)" prop="cost6">
							<el-input v-model.number="costHourGzhForm.cost6"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="超时占用计费标准(元/小时)" prop="cost2">
							<el-input v-model.number="costHourGzhForm.cost2"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="是否上限" prop="cost3">
							<el-radio v-model="costHourGzhForm.cost3" :label=1>{{$t('lang.lab_isYes')}}</el-radio>
							<el-radio v-model="costHourGzhForm.cost3" :label=0>{{$t('lang.lab_isNo')}}</el-radio>
						</el-form-item>
						<!--<el-form-item label="cost3" prop="cost3">
							<el-input v-model.number="costHourForm.cost3"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>-->
						<el-form-item label="超时占用上限(元/天)" prop="cost4" v-if="this.costHourGzhForm.cost3  === 1">
							<el-input v-model.number="costHourGzhForm.cost4"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="缴费后离场时间(分钟)" prop="cost5">
							<el-input v-model.number="costHourGzhForm.cost5"
								:placeholder="$t('lang.lab_please_Input')" class="input-width"
								maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="特来电减免" prop="cost7">
							<el-radio v-model="costHourGzhForm.cost7" :label=1>开启</el-radio>
							<el-radio v-model="costHourGzhForm.cost7" :label=0>关闭</el-radio>
						</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="innerCostHourGzh = false">{{$t('lang.btn_backpage')}}</el-button>
					<el-button type="primary" @click="saveCostHourGzh('costHourGzhForm')">{{$t('lang.btn_save')}}</el-button>
				</div>
			</el-dialog>
			<el-dialog width="50%" :title="$t('lang.trialDetailBtn')" :visible.sync="innerTiming" append-to-body>
				<el-form :model="timingForm" :rules="timingRule" ref="timingForm" class="wid100" :label-width="require('@/config/enum').c_ws12"
					:label-suffix="require('@/config/enum').c_colon">
					<el-form-item :label="$t('lang.lab_costName')" prop="costName">
							<el-input v-model="timingForm.costName" :placeholder="$t('lang.lab_please_Input')"
								class="input-width" maxlength="50"></el-input>
					</el-form-item>
					<el-form-item label="开始时间" prop="cost1">
							<el-time-picker v-model="timingForm.cost1" :picker-options="{selectableRange: '00:00:00 - 23:59:00'}" placeholder="开始时间" value-format="HH:mm"></el-time-picker>
						</el-form-item>
						<el-form-item label="结束时间" prop="cost2">
							<el-time-picker v-model="timingForm.cost2" :picker-options="{selectableRange: '00:00:00 - 23:59:00'}" placeholder="结束时间" value-format="HH:mm"></el-time-picker>
						</el-form-item>							
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="innerTiming = false">{{$t('lang.btn_backpage')}}</el-button>
					<el-button type="primary" @click="saveTiming('timingForm')">{{$t('lang.btn_save')}}</el-button>
				</div>
			</el-dialog>
			<el-dialog width="50%" title="出入口" :visible.sync="innerTempCheckGate" append-to-body>
				<el-form :model="tempCheckGateForm" ref="tempCheckGateForm" class="wid100" :label-width="require('@/config/enum').c_ws12"
					:label-suffix="require('@/config/enum').c_colon">
					<el-form-item prop="gateList">
						<el-checkbox-group v-model="gateList" class="checkbox-group">
							<el-checkbox v-for="(item,index) in gates" :key="index" :label="item.value">
							{{item.name}}</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="innerTempCheckGate = false">{{$t('lang.btn_backpage')}}</el-button>
					<el-button type="primary" @click="saveTempCheckGate('tempCheckGateForm')">{{$t('lang.btn_save')}}</el-button>
				</div>
			</el-dialog>
			<div slot="footer" class="dialog-footer">
				<el-button @click="parkRuleDialog = false">{{$t('lang.btn_backpage')}}</el-button>
				<el-button type="primary" @click="saveParkRule()">{{$t('lang.btn_save')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

	export default {
		data() {
			return {
				parkSaveData: '',
				gateSaveData: '',
				cameraSaveData: '',
				title: '', // 左边的标题
				/* tree数据 */
				treeData: [],
							
				treeChild: '', // 存储子数据
				/* tree子数据结构 */
				defaultProps: {
					children: 'children',
					label: 'Name',
				},
				filterText: '', // 关键词检索
				isDisabled: true, // 修改的可点击
				isShowForm: false, // 是否显示表单(控制按钮)
				addOrEdit: 0, // 1添加  2修改
				type: 0, // 菜单级别
				parkRuleDialog: false, // 是否打开车场规则dialog
				xspszDialog: false,
				xspszDialog1: false,
				sxtxxDialog: false,
				carTeamDialog: false,
				carWxpayDialog: false,
				parkId: '',
				gateId: '',
				cameraId: '',
				options: this.$i18n.t('lang.optionsCarStandard'),
				options1: this.$i18n.t('lang.optionsCarStandard1'),
				optionsCarStore: this.$i18n.t('lang.optionsCarStoreStandard'),
				innerCostHour: false,
				innerCostCount: false,
				innerStoreCostHour: false,
				innerStoreCount: false,
				innerCostHourDiscount: false,
				innerCostHourDerate: false,
				innerCostHourGzh: false,
				innerTiming: false,
				innerTempCheckGate: false,
				gates: [],
				gateList: [],
				pickerOptions1: {
					shortcuts: [{
						text: '今天',
						onClick(picker) {
						picker.$emit('pick', new Date())
						}
					}, {
						text: '昨天',
						onClick(picker) {
						const date = new Date()
						date.setTime(date.getTime() - 3600 * 1000 * 24)
						picker.$emit('pick', date)
						}
					}, {
						text: '一周前',
						onClick(picker) {
						const date = new Date()
						date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
						picker.$emit('pick', date)
						}
					}]
				},
				/* 车场表单 */
				form: {
					parkName: '', // 车场名
					totalNum: 0, // 总车位数
					storeNum: 0,
					tmpNum: 0,
					fixNum: 0,
					nePark: 0,
					isFakePlate: 0,
					placeCountMix: 0,
					guestCar: 0,
					placeCountShow: '',
					parkHost: '',
					parkAppKey: '',
					parkAppSecret: '',
					parkCode: '',
					placeCountType: 0,
					gateName: '', // 出入口名
					gateCode: '',
					parkType: '', // 车场类型：1大车场 2小车场

					gateType: '', // 出入口类型： 1入口 2出口
					cameraName: '', // 摄像头名
					gateRoadwayCode: '',
					cameraNum: '', // 摄像头编号
					cameraNumOn: '', // 开闸摄像头编号
					cameraType: '', // 摄像头类型：1主 2辅
					screenType: 4, // 显示屏类型 1标准 2简易
					pushType: 2, // 推送类型 1阿里云 2mqtt
					cameraUrl: '', // 摄像头地址
					cameraUrlLan: '' // 摄像头地址
				},
				sxtxxForm: {},
				carTeamForm: {
					state : 0
				},
				storeCountForm: {
					costName: '',
					cost2: 0,
					cost1: 0
				},
				costHourForm: {
					costName: '',
					cost1: 0,
					cost2: 0,
					cost3: 0,
					cost4: 0,
					cost5: 0,
					cost6: 0,
					cost7: 0
				},
				costCountForm: {
					costName: '',
					cost1: 0,
					cost2: 0,
					cost5: 0
				},
				storeCostHourForm: {
					costName: '',
					cost1: 0,
					cost2: 0,
					cost3: 0,
					cost4: 0,
					cost5: 0
				},
				xspszForm: {
					yinliang: 9,
					timeSetByHand: '',
					hang1: '',
					hang2: '',
					hang3: '',
					hang4: '',
				},
				xspszForm1: {
					yinliang: 90,
					timeSetByHand: '',
					hang1: '',
					hang2: '',
					hang3: '',
					hang4: '',
				},
				costHourDiscountForm: {
					costName: '',
					cost1: 0,
					cost2: 0,
					cost3: 0,
					cost4: 0,
					cost5: 0
				},
				costHourDerateForm: {
					costName: '',
					keyword: '',
					adminId: '',
					adminName: '',
					isUseCountMonth: 0,
					cost1: 0,
					cost2: 0,
					cost3: 0,
					cost4: 0,
					cost5: 0,
					cost6: 0,
					cost7: 0
				},
				costHourGzhForm: {
					costName: '',
					cost1: 0,
					cost6: 0,
					cost7: 0,
					cost2: 0,
					cost3: 0,
					cost4: 0,
					cost5: 0
				},
				timingForm: {
					costName: '',
					cost1: 0,					
					cost2: 0
				},
				tempCheckGateForm: {
					
				},
				storeCountRule: {
					costName: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input'),
						trigger: 'blur'
					}],
					cost1: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							pattern: /^[0-9.]*$/,
							trigger: 'blur',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					cost2: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
				},
				costHourRule: {
					costName: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input'),
						trigger: 'blur'
					}],
					cost1: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					cost2: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					cost3: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					cost4: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					cost5: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
				},
				costCountRule: {
					costName: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input'),
						trigger: 'blur'
					}],
					cost1: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					cost2: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					cost5: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
				},
				storeCostHourRule: {
					costName: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input'),
						trigger: 'blur'
					}],
					cost1: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					cost2: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					cost3: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					cost4: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					cost5: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
				},
				costHourDiscountRule: {
					costName: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input'),
						trigger: 'blur'
					}],
					cost1: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					cost2: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					cost3: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					cost4: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					cost5: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
				},
				costHourDerateRule: {
					costName: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input'),
						trigger: 'blur'
					}],
					cost1: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					cost2: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					cost3: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					cost4: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					cost5: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					cost6: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					cost7: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					adminId: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input'),
						trigger: 'blur'
					}],
					adminName: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input'),
						trigger: 'blur'
					}],
				},
				costHourGzhRule: {
					costName: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input'),
						trigger: 'blur'
					}],
					cost1: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					cost6: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					cost2: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					cost3: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					cost4: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					cost5: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
				},
				timingRule: {
					costName: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input'),
						trigger: 'blur'
					}],
					cost1: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input'),
						trigger: 'blur'
					}],									
					cost2: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input'),
						trigger: 'blur'
					}],				
				},
				tempCheckGateRule: {

				},
				monthlyCosts: [], // 收费标准集合
				parkRuleForm: {
					// 0关闭 1开启
					// 月租车
					isRepeat: 0, // 重复入场
					moreCar: 0, // 一位多车
					noInOut: 0, // 无入场放行
					fullOut: 0, // 车位满放行
					validDay: 0, // 剩余有效提醒天数
					monthlyCost: '', // 月租车收费标准
					// 固定车
					fixIsRepeat: 0, // 重复入场
					fixMoreCar: 0, // 一位多车
					fixNoInOut: 0, // 无入场放行
					fixFullOut: 0, // 车位满放行
					fixValidDay: 0, // 剩余有效提醒天数
					// 储值车
					storeIsRepeat: 0, // 重复入场
					storeNoInOut: 0, // 无入场放行
					storeFullOut: 0, // 车位满放行
					checkGate: 0, // 出入口验证
					stroeNoUseCount: 0, // 余位推送
					storePayStandard: '', // 储值车收费标准
					// 临时车
					temporaryCar: 0, // 是否显示临时车规则
					tempIsRepeat: 0, // 重复入场
					visitorTemporaryCar: 0, // 访客临时车
					confirmTemporaryCar: 0, // 人工确认临时车
					tempFullIn: 0, // 车位满入场
					tempInSmallPark: 0, // 临时车入小车场
					tempNoInOut: 0, // 无入场放行
					tempCheckGate: 0, // 出入口验证
					allowInNum: 0, // 允入车牌类型
					tempTiming: 0, // 定时开启
					nePark: 0, // 新能源车场
					temppayStandard: '', // 临时车标准收费规则
					temppayStandardDiscount: '', // 临时车优惠收费规则
					temppayStandardDerate: '', // 停车减免收费规则
					temppayStandardGzh: '' // 公众号临时车优惠收费规则
				},
				carWxpayForm: {
					appId: '',
					mchId: '',
					mchKey: ''
				},
				carWxpayRule: {
					appId: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input'),
						trigger: 'blur'
					}],
					mchId: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input'),
						trigger: 'blur'
					}],
					mchKey: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input'),
						trigger: 'blur'
					}],
				},
				rule: {
					parkName: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_parkName'),
						trigger: 'blur'
					}],
					totalNum: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_carTtotalNum')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					storeNum: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_carStoreNum')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					fixNum: [{
							required: true,
							message: '请输入固定车位数'
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					tmpNum: [{
							required: true,
							message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_carTmpNum')
						},
						{
							type: 'number',
							message: this.$i18n.t('lang.key_appOrderBy')
						}
					],
					parkHost: [{
						required: true,
						message: '请输入海康停车场地址',
						trigger: 'blur'
					}],
					parkAppKey: [{
						required: true,
						message: '请输入海康停车场key',
						trigger: 'blur'
					}],
					parkAppSecret: [{
						required: true,
						message: '请输入海康停车场秘钥',
						trigger: 'blur'
					}],
					parkCode: [{
						required: true,
						message: '请输入海康停车场唯一标识',
						trigger: 'blur'
					}],
					gateName: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_gateName'),
						trigger: 'blur'
					}],
					gateCode: [{
						required: true,
						message: '请输入海康出入口唯一标识',
						trigger: 'blur'
					}],
					parkType: [{
						required: true,
						message: this.$i18n.t('lang.plh.sel') + this.$i18n.t('lang.lab_parkType'),
						trigger: 'change'
					}],
					gateType: [{
						required: true,
						message: this.$i18n.t('lang.plh.sel') + this.$i18n.t('lang.lab_gateType'),
						trigger: 'change'
					}],
					cameraNum: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_cameraNum'),
						trigger: 'blur'
					}],
					cameraName: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_cameraName'),
						trigger: 'blur'
					}],
					gateRoadwayCode: [{
						required: true,
						message: '请输入海康车道标识',
						trigger: 'blur'
					}],
					cameraType: [{
						required: true,
						message: this.$i18n.t('lang.plh.sel') + this.$i18n.t('lang.lab_cameraType'),
						trigger: 'change'
					}],
					screenType: [{
						required: true,
						message: this.$i18n.t('lang.plh.sel') + this.$i18n.t('lang.lab_screenType'),
						trigger: 'change'
					}],
				},
			}
		},
		computed: {
      ...mapGetters(['gardenId'])
    },
		mounted() {
			this.getTreeData()
			this.getMonthlyCosts()			
		},
		// 监听小区编号
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val)
			},
			form: {
				/* 监听数据 是否禁用保存按钮 */
				handler(newVal, oldVal) {
					if (this.type === 1) {
						var totalNum = Number(newVal.totalNum)
						var storeNum = Number(newVal.storeNum)
						var tmpNum = Number(newVal.tmpNum)
						var fixNum = Number(newVal.fixNum)
						var parkJson = {
							'parkName': newVal.parkName,
							'totalNum': totalNum,
							'storeNum': storeNum,
							'tmpNum': tmpNum,
							'fixNum': fixNum,
							'isFakePlate': newVal.isFakePlate,
							'placeCountMix': newVal.placeCountMix,
							'guestCar': newVal.guestCar,
							'parkHost': newVal.parkHost,
							'parkAppKey': newVal.parkAppKey,
							'parkAppSecret': newVal.parkAppSecret,
							'parkCode': newVal.parkCode,
							'placeCountShow': newVal.placeCountShow,
							'placeCountType': newVal.placeCountType,
							'nePark': newVal.nePark
						}
						let tempRule = JSON.stringify(parkJson)
						if (tempRule === this.parkSaveData) {
							this.isDisabled = true
						} else {
							this.isDisabled = false
						}
					} else if (this.type === 2) {
						var parkType = Number(newVal.parkType)
						var gateJson = {
							'gateName': newVal.gateName,
							'gateCode': newVal.gateCode,
							'parkType': parkType
						}
						let tempRule = JSON.stringify(gateJson)
						if (tempRule === this.gateSaveData) {
							this.isDisabled = true
						} else {
							this.isDisabled = false
						}
					} else {
						var gateType = Number(newVal.gateType)
						var cameraType = Number(newVal.cameraType)
						var screenType = Number(newVal.screenType)
						var pushType = Number(newVal.pushType)
						var cameraJson = {
							'gateType': gateType,
							'cameraName': newVal.cameraName,
							'gateRoadwayCode': newVal.gateRoadwayCode,
							'cameraNum': newVal.cameraNum,
							'cameraNumOn': newVal.cameraNumOn,
							'cameraType': cameraType,
							'screenType': screenType,
							'pushType': pushType,
							'cameraUrl': newVal.cameraUrl,
							'cameraUrlLan': newVal.cameraUrlLan,
						}
						let tempRule = JSON.stringify(cameraJson)
						if (tempRule === this.cameraSaveData) {
							this.isDisabled = true
						} else {
							this.isDisabled = false
						}
					}
				},
				deep: true,
				immediate: true
			}
		},
		methods: {
			appendZero(obj) {
                if (obj < 10) {
                    return '0' + obj
                } else {
                    return obj
                }
            },
			ylSz() {
				if (this.form.cameraNum != '' && this.appendZero(this.xspszForm.yinliang) != '') {
					var loading = this.$loading()
					this.$get(`carVolumeSet?cameraNum=${this.form.cameraNum}&volume=${this.appendZero(this.xspszForm.yinliang)}`)
								.then(res => {
										if (res && res.errCode === 0) {
											this.$message({
												type: 'success',
												message: '音量设置成功'
											})
											loading.close()
										} else {
											this.$message({
												type: 'success',
												message: res.errMsg
											})
										}
									},
									err => {
										loading.close()
										this.$message.error(err)
									})
				}
			},
			ylSz1() {
				if (this.form.cameraNum != '' && this.appendZero(this.xspszForm1.yinliang) != '') {
					var loading = this.$loading()
					this.$get(`carVolumeSet1?cameraNum=${this.form.cameraNum}&volume=${this.appendZero(this.xspszForm1.yinliang)}`)
								.then(res => {
										if (res && res.errCode === 0) {
											this.$message({
												type: 'success',
												message: '音量设置成功'
											})
											loading.close()
										} else {
											this.$message({
												type: 'success',
												message: res.errMsg
											})
										}
									},
									err => {
										loading.close()
										this.$message.error(err)
									})
				}
			},
			szsp() {
				if (this.form.cameraNum != '') {
					var loading = this.$loading()
					this.$get(`carScreenSet?cameraNum=${this.form.cameraNum}`)
								.then(res => {
										if (res && res.errCode === 0) {
											this.$message({
												type: 'success',
												message: '竖屏设置成功'
											})
											loading.close()
										} else {
											this.$message({
												type: 'success',
												message: res.errMsg
											})
										}
									},
									err => {
										loading.close()
										this.$message.error(err)
									})
				}
			},
			tbSj(sjType) {
				var loading = this.$loading()
				if (sjType == '1') {
					let nowTime = new Date().getTime()
					this.$get(`carTimeSet?cameraNum=${this.form.cameraNum}&time=` + nowTime)
								.then(res => {
										if (res && res.errCode === 0) {
											this.$message({
												type: 'success',
												message: '时间同步成功'
											})
											loading.close()
										} else {
											this.$message({
												type: 'success',
												message: res.errMsg
											})
										}
									},
									err => {
										loading.close()
										this.$message.error(err)
									})
				} else if (sjType == '2') {
					if (this.xspszForm.timeSetByHand == '') {
							this.$message({
								type: 'error',
								message: '请选择时间！'
							})
					} else {
							this.$get(`carTimeSet?cameraNum=${this.form.cameraNum}&time=` + this.xspszForm.timeSetByHand)
								.then(res => {
										if (res && res.errCode === 0) {
											this.$message({
												type: 'success',
												message: '时间同步成功'
											})
											loading.close()
										} else {
											this.$message({
												type: 'success',
												message: res.errMsg
											})
										}
									},
									err => {
										loading.close()
										this.$message.error(err)
									})
					}
				}
			},
			tbSj1(sjType) {
				var loading = this.$loading()
				if (sjType == '1') {
					let nowTime = new Date().getTime()
					this.$get(`carTimeSet1?cameraNum=${this.form.cameraNum}&time=` + nowTime)
								.then(res => {
										if (res && res.errCode === 0) {
											this.$message({
												type: 'success',
												message: '时间同步成功'
											})
											loading.close()
										} else {
											this.$message({
												type: 'success',
												message: res.errMsg
											})
										}
									},
									err => {
										loading.close()
										this.$message.error(err)
									})
				} else if (sjType == '2') {
					if (this.xspszForm1.timeSetByHand == '') {
							this.$message({
								type: 'error',
								message: '请选择时间！'
							})
					} else {
							this.$get(`carTimeSet1?cameraNum=${this.form.cameraNum}&time=` + this.xspszForm1.timeSetByHand)
								.then(res => {
										if (res && res.errCode === 0) {
											this.$message({
												type: 'success',
												message: '时间同步成功'
											})
											loading.close()
										} else {
											this.$message({
												type: 'success',
												message: res.errMsg
											})
										}
									},
									err => {
										loading.close()
										this.$message.error(err)
									})
					}
				}
			},
			adSz(rowId) {
				let adInfo = ''
				if (rowId == '01') {
					adInfo = this.xspszForm.hang1
				} else if (rowId == '02') {
					adInfo = this.xspszForm.hang2
				} else if (rowId == '03') {
					adInfo = this.xspszForm.hang3
				} else if (rowId == '04') {
					adInfo = this.xspszForm.hang4
				} else {
					adInfo = ''
				}
				if (adInfo == '') {
					this.$message({
						type: 'error',
						message: '请填写广告文字!'
					})
				} else {
					var loading = this.$loading()
					this.$get(`carAdSet?cameraNum=${this.form.cameraNum}&ad=` + adInfo + `&rowId=` + rowId)
								.then(res => {
										if (res && res.errCode === 0) {
											this.$message({
												type: 'success',
												message: '广告内容设置成功'
											})
											loading.close()
										} else {
											this.$message({
												type: 'success',
												message: res.errMsg
											})
										}
									},
									err => {
										loading.close()
										this.$message.error(err)
									})
				}
			},
			adSz1(rowId) {
				let adInfo = ''
				if (rowId == '00') {
					adInfo = this.xspszForm1.hang1
				} else if (rowId == '01') {
					adInfo = this.xspszForm1.hang2
				} else if (rowId == '02') {
					adInfo = this.xspszForm1.hang3
				} else if (rowId == '03') {
					adInfo = this.xspszForm1.hang4
				}else {
					adInfo = ''
				}
				if (adInfo == '') {
					this.$message({
						type: 'error',
						message: '请填写广告文字!'
					})
				} else {
					var loading = this.$loading()
					this.$get(`carAdSet1?cameraNum=${this.form.cameraNum}&ad=` + adInfo + `&rowId=` + rowId)
								.then(res => {
										if (res && res.errCode === 0) {
											this.$message({
												type: 'success',
												message: '广告内容设置成功'
											})
											loading.close()
										} else {
											this.$message({
												type: 'success',
												message: res.errMsg
											})
										}
									},
									err => {
										loading.close()
										this.$message.error(err)
									})
				}
			},
			/* 获取tree数据 */
			getTreeData() {
				let loading = this.$loading()
				this.$get(`/CarPark/selectAllList?gardenId=` + this.gardenId)
					.then(res => {
							loading.close()
							this.treeData = res.list
						},
						err => {
							loading.close()
							this.$message.error(err)
						})
			},
			// 获取月租车收费标准List
			getMonthlyCosts(val) {
				this.$get(`carMonthlyCost?pageNo=1&pageSize=999&parkId=` + this.parkId).then(
					res => {
						if (res && res.errCode === 0) {
							this.monthlyCosts = res.list
						}
					},
					error => {
						this.$message.error(error)
					}
				)
			},
			// 获取车场信息
			getParkById(id) {
				let loading = this.$loading()
				this.$get(`/carPark/` + id).then(
					res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.form.parkName = res.carPark.parkName
							this.form.totalNum = res.carPark.totalNum
							this.form.storeNum = res.carPark.storeNum
							this.form.tmpNum = res.carPark.tmpNum
							this.form.fixNum = res.carPark.fixNum
							this.form.isFakePlate = res.carPark.isFakePlate
							this.form.placeCountMix = res.carPark.placeCountMix
							this.form.guestCar = res.carPark.guestCar
							this.form.parkHost = res.carPark.parkHost
							this.form.parkAppKey = res.carPark.parkAppKey
							this.form.parkAppSecret = res.carPark.parkAppSecret
							this.form.parkCode = res.carPark.parkCode
							this.form.placeCountShow = res.carPark.placeCountShow
							this.form.placeCountType = res.carPark.placeCountType
							this.form.nePark = res.carPark.isNewEnergyCar
							// 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
							var park = {
								'parkName': res.carPark.parkName,
								'totalNum': res.carPark.totalNum,
								'storeNum': res.carPark.storeNum,
								'tmpNum': res.carPark.tmpNum,
								'fixNum': res.carPark.fixNum,
								'isFakePlate': res.carPark.isFakePlate,
								'placeCountMix': res.carPark.placeCountMix,
								'guestCar': res.carPark.guestCar,
								'parkHost': res.carPark.parkHost,
								'parkAppKey': res.carPark.parkAppKey,
								'parkAppSecret': res.carPark.parkAppSecret,
								'parkCode': res.carPark.parkCode,
								'placeCountShow': res.carPark.placeCountShow,
								'placeCountType': res.carPark.placeCountType,
								'nePark': res.carPark.isNewEnergyCar
							}
							this.parkSaveData = JSON.stringify(park)
						}
					},
					err => {
						loading.close()
						this.$message.error(err)
					}
				)
			},
			// 获取出入口信息
			getGateById(id) {
				let loading = this.$loading()
				this.$get(`/carGate/` + id).then(
					res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.form.gateName = res.carGate.gateName
							this.form.gateCode = res.carGate.gateCode
							this.form.parkType = res.carGate.parkType
							// 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
							var gate = {
								'gateName': res.carGate.gateName,
								'gateCode': res.carGate.gateCode,
								'parkType': res.carGate.parkType
							}
							this.gateSaveData = JSON.stringify(gate)
						}
					},
					err => {
						loading.close()
						this.$message.error(err)
					})
			},
			// 获取摄像头信息
			getCameraById(id) {
				let loading = this.$loading()
				this.$get(`/carGateCamera/` + id).then(
					res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.form.gateType = res.camera.gateType
							this.form.gateRoadwayCode = res.camera.gateRoadwayCode
							this.form.cameraName = res.camera.cameraName
							this.form.cameraNum = res.camera.cameraNum
							this.form.cameraNumOn = res.camera.cameraNumOn
							this.form.cameraType = res.camera.cameraType
							this.form.screenType = res.camera.screenType
							this.form.pushType = res.camera.pushType
							this.form.cameraUrl = res.camera.cameraUrl
							this.form.cameraUrlLan = res.camera.cameraUrlLan
							// 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
							var camera = {
								'gateType': res.camera.gateType,
								'gateRoadwayCode': res.camera.gateRoadwayCode,
								'cameraName': res.camera.cameraName,
								'cameraNum': res.camera.cameraNum,
								'cameraNumOn': res.camera.cameraNumOn,
								'cameraType': res.camera.cameraType,
								'screenType': res.camera.screenType,
								'pushType': res.camera.pushType,
								'cameraUrl': res.camera.cameraUrl,
								'cameraUrlLan': res.camera.cameraUrlLan,
							}
							this.cameraSaveData = JSON.stringify(camera)
						}
					},
					err => {
						loading.close()
						this.$message.error(err)
					}
				)
			},
			// 关键字搜索
			filterNode(value, data) {
				if (!value) return true
				return data.Name.indexOf(value) != -1
			},
			addPark() {
				this.form.parkName = ''
				this.form.totalNum = 0
				this.form.storeNum = 0
				this.form.tmpNum = 0
				this.form.fixNum = 0
				this.form.isFakePlate = 0
				this.form.placeCountMix = 0
				this.form.guestCar = 0
				this.form.parkHost = ''
				this.form.parkAppSecret = ''
				this.form.parkAppKey = ''
				this.form.parkCode = ''
				this.form.placeCountShow = ''
				this.form.placeCountType = 0
				this.form.nePark = 0
				this.isShowForm = true
				this.type = 1
				this.title = this.$i18n.t('lang.btn_add')
				this.addOrEdit = 1
			},
			addGate() {
				if (this.type != 1) {
					this.$message.error(this.$i18n.t('lang.lab_addGateErrMessage'))
				} else {
					this.form.gateName = ''
					this.form.gateCode = ''
					this.form.parkType = ''
					this.isShowForm = true
					this.type = 2
					this.title = this.$i18n.t('lang.btn_add')
					this.addOrEdit = 1
				}
			},
			addCamera() {
				if (this.type != 2) {
					this.$message.error(this.$i18n.t('lang.lab_addCameraErrMessage'))
				} else {
					this.form.cameraName = ''
					this.form.gateRoadwayCode = ''
					this.form.gateType = ''
					this.form.cameraNum = ''
					this.form.cameraNumOn = ''
					this.form.cameraType = ''
					this.form.screenType = 4
					this.form.pushType = 2
					this.form.cameraUrl = ''
					this.form.cameraUrlLan = ''
					this.isShowForm = true
					this.type = 3
					this.title = this.$i18n.t('lang.btn_add')
					this.addOrEdit = 1
				}
			},
			del() {
				var loading = this.$loading()
				var data = this.treeChild
				if (data.children != null && data.children.length > 0) {
					this.$message.error(this.$i18n.t('lang.lab_carDelChild'))
					loading.close()
				} else {
					if (data.Type === 1) {
						this.$delete(`/carPark/` + data.Id).then(
							res => {
								loading.close()
								this.getTreeData()
								this.isShowForm = false
								this.$message.success(this.$i18n.t('lang.lab_del_success'))
								this.title = ''
							},
							err => {
								loading.close()
								this.$message.error(err)
							})
					} else if (data.Type === 2) {
						this.$delete(`/carGate/` + data.Id).then(
							res => {
								loading.close()
								this.getTreeData()
								this.isShowForm = false
								this.$message.success(this.$i18n.t('lang.lab_del_success'))
								this.title = ''
							},
							err => {
								loading.close()
								this.$message.error(err)
							})
					} else {
						this.$delete(`/carGateCamera/` + data.Id).then(
							res => {
								loading.close()
								this.getTreeData()
								this.isShowForm = false
								this.$message.success(this.$i18n.t('lang.lab_del_success'))
								this.title = ''
							},
							err => {
								loading.close()
								this.$message.error(err)
							})
					}
				}
			},
			handleNodeClick(data) {
				this.isShowForm = true
				this.type = data.Type
				this.title = this.$i18n.t('lang.btn_modify')
				this.addOrEdit = 2
				this.treeChild = data
				if (this.type === 1) {
					this.getParkById(data.Id)
					this.parkId = data.Id
				} else if (this.type === 2) {
					this.getGateById(data.Id)
					this.gateId = data.Id
				} else {
					this.getCameraById(data.Id)
					this.cameraId = data.Id
				}
			},
			clear() {
				if (this.type === 1) {
					this.form.parkName = ''
					this.form.totalNum = 0
					this.form.storeNum = 0
					this.form.tmpNum = 0
					this.form.fixNum = 0
					this.form.isFakePlate = 0
					this.form.placeCountMix = 0
					this.form.guestCar = 0
					this.form.placeCountShow = ''
					this.form.parkHost = ''
					this.form.parkAppSecret = ''
					this.form.parkAppKey = ''
					this.form.parkCode = ''
					this.form.placeCountType = 0
					this.form.nePark = 0
				} else if (this.type === 2) {
					this.form.gateName = ''
					this.form.gateCode = ''
					this.form.parkType = ''
				} else {
					this.form.gateType = ''
					this.form.cameraNum = ''
					this.form.cameraNumOn = ''
					this.form.cameraName = ''
					this.form.gateRoadwayCode = ''
					this.form.cameraType = ''
					this.form.screenType = 4
					this.form.pushType = 2
					this.form.cameraUrl = ''
					this.form.cameraUrlLan = ''
				}
			},
			openXspsz(form) {
				if (this.form.cameraNum != null && this.form.cameraNum != '') {
					this.xspszDialog = true
					this.xspszForm.timeSetByHand = ''
					this.xspszForm.hang1 = ''
					this.xspszForm.hang2 = ''
					this.xspszForm.hang3 = ''
					this.xspszForm.hang4 = ''
				} else {
					this.$message.error('请填写摄像头编号!')
				}
			},
			openXspsz1(form) {
				if (this.form.cameraNum != null && this.form.cameraNum != '') {
					this.xspszDialog1 = true
					this.xspszForm.timeSetByHand = ''
					this.xspszForm.hang1 = ''
					this.xspszForm.hang2 = ''
					this.xspszForm.hang3 = ''
					this.xspszForm.hang4 = ''
				} else {
					this.$message.error('请填写摄像头编号!')
				}
			},
			openSxtxx(form) {
				if (this.form.cameraNum != null && this.form.cameraNum != '') {
					this.sxtxxDialog = true	
					let loading = this.$loading()
					this.$get(`/carDevicesInfo/` + this.form.cameraNum).then(
						res => {
						loading.close()
						if (res && res.errCode === 0) {
							if (res.data != null) {								
								this.sxtxxForm = res.data	
							}
						}
						},
						error => {
						loading.close()
						this.$message.error(error)
						}
					)				
				} else {
					this.$message.error('请填写摄像头编号!')
				}
			},
			carTeam(form) {
				let that = this
				if (that.form.cameraNum != null && that.form.cameraNum != '') {	
					let params = {}					
					let loading = this.$loading()
					that.$post(`/carTeamMqttState?deviceName=` + that.form.cameraNum, params).then(
					res => {
						if (res && res.errCode === 0) {
							let counter = 0;
							let interval = setInterval(() => {
							if (counter < 5) {
								that.$post(`/getCarTeamMqttState?deviceName=` + that.form.cameraNum, params).then(
									res => {
										if (res && res.errCode === 0) {
											if (res.state == '') {	
												counter = counter + 1
												if (counter == 4) {
													clearInterval(interval); 
													loading.close()
													that.$message.error('获取数据失败')				
												}				
											} else {
												this.$message.success(this.$i18n.t('lang.lab_trialSuccess'))
												clearInterval(interval); 
												//that.carTeamForm.state = res.state
												that.$set(that.carTeamForm,"state",res.state-0)
												that.carTeamDialog = true	
												loading.close()												
											}
										}
									},
									error => {
										loading.close()
										that.$message.error(error)
									}
									)
								} else {
									clearInterval(interval); 
								}
							}, 1000); 					
							
						}
					},
					error => {
						loading.close()
						that.$message.error(error)
					}
					)
				} else {
					that.$message.error('请填写摄像头编号!')
				}
			},
			carTeamSet() {
				this.carTeamDialog = false
				if (this.form.cameraNum != null && this.form.cameraNum != '') {	
					let params = {}	
					this.$post(`/carTeamMqtt?deviceName=` + this.form.cameraNum + `&state=` + this.carTeamForm.state, params).then(
					res => {
						if (res && res.errCode === 0) {									
							this.carTeam('form')
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					}
					)
				} else {
					that.$message.error('请填写摄像头编号!')
				}
				

			},
			yckz(form) {
				if (this.form.cameraNum != null && this.form.cameraNum != '') {
					this.$get(`/carDevicesWeb/` + this.form.cameraNum).then(
						res => {
						if (res && res.errCode === 0 && res.url != '') {
							window.open(res.url)
						}
						},
						error => {
						this.$message.error(error)
						}
					)
				}
			},
			save(form) {
				let loading = this.$loading()
				if (this.addOrEdit === 1) {
					if (this.type === 1) { // 添加车场
						this.$refs[form].validate((valid) => {
							if (valid) {
								this.isDisabled = true
								this.$post(`/carPark`, {
									parkName: this.form.parkName,
									totalNum: this.form.totalNum,
									storeNum: this.form.storeNum,
									tmpNum: this.form.tmpNum,
									fixNum: this.form.fixNum,
									isFakePlate: this.form.isFakePlate,
									placeCountMix: this.form.placeCountMix,
									guestCar: this.form.guestCar,
									parkHost: this.form.parkHost,
									parkAppKey: this.form.parkAppKey,
									parkAppSecret: this.form.parkAppSecret,
									parkCode: this.form.parkCode,
									placeCountShow: this.form.placeCountShow,
									placeCountType: this.form.placeCountType,
									isNewEnergyCar: this.form.nePark,
									gardenId: this.gardenId
								}).then(
									res => {
										loading.close()
										this.getTreeData()
										this.isShowForm = false
										this.$message.success(this.$i18n.t('lang.lab_add_success'))
										this.title = ''
									},
									err => {
										loading.close()
										this.$message.error(err)
									}
								)
							} else {
								loading.close()
							}
						})
					} else if (this.type === 2) { // 添加出入口
						this.$refs[form].validate((valid) => {
							if (valid) {
								this.isDisabled = true
								this.$post(`/carGate`, {
									'gateName': this.form.gateName,
									'gateCode': this.form.gateCode,
									'parkId': this.parkId,
									'parkType': this.form.parkType
								}).then(
									res => {
										loading.close()
										this.getTreeData()
										this.isShowForm = false
										this.$message.success(this.$i18n.t('lang.lab_add_success'))
										this.title = ''
									},
									err => {
										loading.close()
										this.$message.error(err)
									}
								)
							} else {
								loading.close()
							}
						})
					} else { // 添加摄像头
						this.$refs[form].validate((valid) => {
							if (valid) {
								this.isDisabled = true						
								this.$post(`/carGateCamera`, {
									'gateId': this.gateId,
									'gardenId': this.gardenId,
									'gateType': this.form.gateType,
									'cameraNum': this.form.cameraNum,
									'cameraNumOn': this.form.cameraNumOn,
									'cameraName': this.form.cameraName,
									'gateRoadwayCode': this.form.gateRoadwayCode,
									'cameraType': this.form.cameraType,
									'screenType': this.form.screenType,
									'pushType': this.form.pushType,
									'cameraUrl': this.form.cameraUrl,
									'cameraUrlLan': this.form.cameraUrlLan
								}).then(
									res => {
										loading.close()
										this.getTreeData()
										this.isShowForm = false
										this.$message.success(this.$i18n.t('lang.lab_add_success'))
										this.title = ''
									},
									err => {
										loading.close()
										this.$message.error(err)
									}
								)
							} else {
								loading.close()
							}
						})
					}
				} else if (this.addOrEdit === 2) {
					if (this.type === 1) { // 修改车场
						this.$refs[form].validate((valid) => {
							if (valid) {
								this.isDisabled = true
								this.$patch(`/carPark/` + this.parkId, {
									parkName: this.form.parkName,
									totalNum: this.form.totalNum,
									storeNum: this.form.storeNum,
									tmpNum: this.form.tmpNum,
									fixNum: this.form.fixNum,
									isFakePlate: this.form.isFakePlate,
									placeCountMix: this.form.placeCountMix,
									guestCar: this.form.guestCar,
									parkHost: this.form.parkHost,
									parkAppKey: this.form.parkAppKey,
									parkAppSecret: this.form.parkAppSecret,
									parkCode: this.form.parkCode,
									placeCountShow: this.form.placeCountShow,
									placeCountType: this.form.placeCountType,
									isNewEnergyCar: this.form.nePark,
								}).then(
									res => {
										loading.close()
										this.getTreeData()
										this.isShowForm = false
										this.$message.success(this.$i18n.t('lang.lab_modify_success'))
										this.title = ''
									},
									err => {
										loading.close()
										this.$message.error(err)
									})
							} else {
								loading.close()
							}
						})
					} else if (this.type === 2) { // 修改出入口
						this.$refs[form].validate((valid) => {
							if (valid) {
								this.isDisabled = true
								this.$patch(`/carGate/` + this.gateId, {
									'gateName': this.form.gateName,
									'gateCode': this.form.gateCode,
									'parkType': this.form.parkType
								}).then(
									res => {
										loading.close()
										this.getTreeData()
										this.isShowForm = false
										this.$message.success(this.$i18n.t('lang.lab_modify_success'))
										this.title = ''
									},
									err => {
										loading.close()
										this.$message.error(err)
									})
							} else {
								loading.close()
							}
						})
					} else { // 修改摄像头					    
						this.$refs[form].validate((valid) => {
							if (valid) {
								this.isDisabled = true
								this.$patch(`/carGateCamera/` + this.cameraId, {
									'gateType': this.form.gateType,
									'cameraNum': this.form.cameraNum,
									'cameraNumOn': this.form.cameraNumOn,
									'cameraName': this.form.cameraName,
									'gateRoadwayCode': this.form.gateRoadwayCode,
									'cameraType': this.form.cameraType,
									'screenType': this.form.screenType,
									'pushType': this.form.pushType,
									'cameraUrl': this.form.cameraUrl,
									'cameraUrlLan': this.form.cameraUrlLan
								}).then(
									res => {
										loading.close()
										this.getTreeData()
										this.isShowForm = false
										this.$message.success(this.$i18n.t('lang.lab_modify_success'))
										this.title = ''
									},
									err => {
										loading.close()
										this.$message.error(err)
									})
							} else {
								loading.close()
							}
						})
					}
				}
			},
			/* 车场规则 */
			openParkRule(formName) {
				this.parkRuleDialog = true
				this.parkRuleForm.isRepeat = 0
				this.parkRuleForm.moreCar = 0
				this.parkRuleForm.noInOut = 0
				this.parkRuleForm.fullOut = 0
				this.parkRuleForm.validDay = 365
				this.parkRuleForm.fixIsRepeat = 0
				this.parkRuleForm.fixMoreCar = 0
				this.parkRuleForm.fixNoInOut = 0
				this.parkRuleForm.fixFullOut = 0
				this.parkRuleForm.fixValidDay = 365
				this.parkRuleForm.monthlyCost = ''
				this.parkRuleForm.storeIsRepeat = 0
				this.parkRuleForm.storeNoInOut = 0
				this.parkRuleForm.storeFullOut = 0
				this.parkRuleForm.checkGate = 0
				this.parkRuleForm.stroeNoUseCount = 0
				this.parkRuleForm.storePayStandard = 1
				this.parkRuleForm.temporaryCar = 0
				this.parkRuleForm.tempIsRepeat = 0
				this.parkRuleForm.visitorTemporaryCar = 0
				this.parkRuleForm.confirmTemporaryCar = 0
				this.parkRuleForm.tempFullIn = 0
				this.parkRuleForm.tempInSmallPark = 0
				this.parkRuleForm.tempNoInOut = 0
				this.parkRuleForm.tempCheckGate = 0
				this.parkRuleForm.allowInNum = 0
				this.parkRuleForm.tempTiming = 0
				this.parkRuleForm.nePark = 0
				this.parkRuleForm.temppayStandard = 1
				this.parkRuleForm.temppayStandardDiscount = 1
				this.parkRuleForm.temppayStandardDerate = 1
				this.parkRuleForm.temppayStandardGzh = 1

				var loading = this.$loading()
				this.$get(`carCommonRule`, {
						parkId: this.parkId
					})
					.then(
						res => {
							loading.close()
							for (let a in res.list) {
								if (res.list[a].ruleKey == 'isRepeat') {
									this.parkRuleForm.isRepeat = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'moreCar') {
									this.parkRuleForm.moreCar = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'noInOut') {
									this.parkRuleForm.noInOut = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'fullOut') {
									this.parkRuleForm.fullOut = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'validDay') {
									this.parkRuleForm.validDay = res.list[a].ruleValue
								}
								/* if (res.list[a].ruleKey == 'monthlyCost') {
									this.parkRuleForm.monthlyCost = res.list[a].ruleValue
								} */
								if (res.list[a].ruleKey == 'fixIsRepeat') {
									this.parkRuleForm.fixIsRepeat = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'fixMoreCar') {
									this.parkRuleForm.fixMoreCar = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'fixNoInOut') {
									this.parkRuleForm.fixNoInOut = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'fixFullOut') {
									this.parkRuleForm.fixFullOut = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'fixValidDay') {
									this.parkRuleForm.fixValidDay = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'storeIsRepeat') {
									this.parkRuleForm.storeIsRepeat = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'storeNoInOut') {
									this.parkRuleForm.storeNoInOut = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'storeFullOut') {
									this.parkRuleForm.storeFullOut = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'checkGate') {
									this.parkRuleForm.checkGate = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'stroeNoUseCount') {
									this.parkRuleForm.stroeNoUseCount = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'storePayStandard') {
									this.parkRuleForm.storePayStandard = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'tempIsRepeat') {
									this.parkRuleForm.tempIsRepeat = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'visitorTemporaryCar') {
									this.parkRuleForm.visitorTemporaryCar = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'confirmTemporaryCar') {
									this.parkRuleForm.confirmTemporaryCar = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'tempFullIn') {
									this.parkRuleForm.tempFullIn = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'tempInSmallPark') {
									this.parkRuleForm.tempInSmallPark = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'tempNoInOut') {
									this.parkRuleForm.tempNoInOut = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'tempCheckGate') {
									this.parkRuleForm.tempCheckGate = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'allowInNum') {
									this.parkRuleForm.allowInNum = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'tempTiming') {
									this.parkRuleForm.tempTiming = res.list[a].ruleValue
								}								
								if (res.list[a].ruleKey == 'nePark') {
									this.parkRuleForm.nePark = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'temppayStandard') {
									this.parkRuleForm.temppayStandard = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'temppayStandardDiscount') {
									this.parkRuleForm.temppayStandardDiscount = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'temppayStandardDerate') {
									this.parkRuleForm.temppayStandardDerate = res.list[a].ruleValue
								}
								if (res.list[a].ruleKey == 'temppayStandardGzh') {
									this.parkRuleForm.temppayStandardGzh = res.list[a].ruleValue
								}
								if (res.list.length > 16) {
									this.parkRuleForm.temporaryCar = 1
								} else {
									this.parkRuleForm.temporaryCar = 0
								}
							}
						},
						err => {
							loading.close()
							this.$message.error(err)
						}
					)
			},
			opencarWxpay(formName) {				
				var loading = this.$loading()
				this.$get(`carWxpay/` + this.gardenId + `/` + this.parkId, {})
					.then(
						res => {
							loading.close()
							if (res && res.errCode === 0) {
								this.carWxpayDialog = true
								this.carWxpayForm.appId = res.carWxpay.appId
								this.carWxpayForm.mchId = res.carWxpay.mchId
								this.carWxpayForm.mchKey = res.carWxpay.mchKey
							}
						},
						err => {
							loading.close()
							this.$message.error(err)
						}
					)
			},
			/* 月租车收费标准 */
			openMonthlyCost() {
				this.$router.push({
					name: 'carMonthlyCostList',
					query: {
						parkId: this.parkId,
						gardenId: this.gardenId
					}
				})
			},
			/* 保存车场规则 */
			saveParkRule() {
				// this.parkRuleDialog = false
				var parkRuleList = []
				for (let a in this.parkRuleForm) {
					if (a == 'isRepeat') {
						parkRuleList.push({
							'ruleName': '重复入场',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 1,
							'parkId': this.parkId
						})
					}
					if (a == 'moreCar') {
						parkRuleList.push({
							'ruleName': '一位多车',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 1,
							'parkId': this.parkId
						})
					}
					if (a == 'noInOut') {
						parkRuleList.push({
							'ruleName': '无入场放行',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 1,
							'parkId': this.parkId
						})
					}
					if (a == 'fullOut') {
						parkRuleList.push({
							'ruleName': '车位满放行',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 1,
							'parkId': this.parkId
						})
					}
					if (a == 'validDay') {
						parkRuleList.push({
							'ruleName': '剩余提醒天数',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 1,
							'parkId': this.parkId
						})
					}
					/* if (a == 'monthlyCost') {
						parkRuleList.push({
							'ruleName': '月租车收费标准',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 1,
							'parkId': this.parkId
						})
					} */
					if (a == 'fixIsRepeat') {
						parkRuleList.push({
							'ruleName': '固定车重复入场',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 3,
							'parkId': this.parkId
						})
					}
					if (a == 'fixMoreCar') {
						parkRuleList.push({
							'ruleName': '固定车一位多车',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 3,
							'parkId': this.parkId
						})
					}
					if (a == 'fixNoInOut') {
						parkRuleList.push({
							'ruleName': '固定车无入场放行',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 3,
							'parkId': this.parkId
						})
					}
					if (a == 'fixFullOut') {
						parkRuleList.push({
							'ruleName': '固定车车位满放行',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 3,
							'parkId': this.parkId
						})
					}
					if (a == 'fixValidDay') {
						parkRuleList.push({
							'ruleName': '固定车剩余提醒天数',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 3,
							'parkId': this.parkId
						})
					}
					if (a == 'storeIsRepeat') {
						parkRuleList.push({
							'ruleName': '储值车重复入场',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 2,
							'parkId': this.parkId
						})
					}
					if (a == 'storeNoInOut') {
						parkRuleList.push({
							'ruleName': '储值车无入场放行',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 2,
							'parkId': this.parkId
						})
					}
					if (a == 'storeFullOut') {
						parkRuleList.push({
							'ruleName': '储值车车位满放行',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 2,
							'parkId': this.parkId
						})
					}
					if (a == 'checkGate') {
						parkRuleList.push({
							'ruleName': '验证出入口',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 2,
							'parkId': this.parkId
						})
					}
					if (a == 'stroeNoUseCount') {
						parkRuleList.push({
							'ruleName': '余位推送',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 2,
							'parkId': this.parkId
						})
					}
					if (a == 'storePayStandard') {
						parkRuleList.push({
							'ruleName': '储值车收费标准',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 2,
							'parkId': this.parkId
						})
					}
					if (a === 'temporaryCar') {
						if (this.parkRuleForm[a] === 0) {
							break
						}
					}
					if (a == 'tempIsRepeat') {
						parkRuleList.push({
							'ruleName': '重复入场',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 0,
							'parkId': this.parkId
						})
					}
					if (a == 'visitorTemporaryCar') {
						parkRuleList.push({
							'ruleName': '访客临时车',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 0,
							'parkId': this.parkId
						})
					}
					if (a == 'confirmTemporaryCar') {
						parkRuleList.push({
							'ruleName': '人工确认',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 0,
							'parkId': this.parkId
						})
					}
					if (a == 'tempFullIn') {
						parkRuleList.push({
							'ruleName': '车位满入场',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 0,
							'parkId': this.parkId
						})
					}
					if (a == 'tempInSmallPark') {
						parkRuleList.push({
							'ruleName': '临时车入小车场',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 0,
							'parkId': this.parkId
						})
					}
					if (a == 'tempNoInOut') {
						parkRuleList.push({
							'ruleName': '无入场放行',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 0,
							'parkId': this.parkId
						})
					}
					if (a == 'tempCheckGate') {
						parkRuleList.push({
							'ruleName': '临时车出入口验证',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 0,
							'parkId': this.parkId
						})
					}
					if (a == 'allowInNum') {
						parkRuleList.push({
							'ruleName': '允入车牌类型',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 0,
							'parkId': this.parkId
						})
					}
					if (a == 'tempTiming') {
						parkRuleList.push({
							'ruleName': '定时开启',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 0,
							'parkId': this.parkId
						})
					}					
					if (a == 'nePark') {
						parkRuleList.push({
							'ruleName': '新能源车场',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 0,
							'parkId': this.parkId
						})
					}
					if (a == 'temppayStandard') {
						parkRuleList.push({
							'ruleName': '临时车标准收费规则',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 0,
							'parkId': this.parkId
						})
					}
					if (a == 'temppayStandardDiscount') {
						parkRuleList.push({
							'ruleName': '临时车优惠收费规则',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 0,
							'parkId': this.parkId
						})
					}
					if (a == 'temppayStandardDerate') {
						parkRuleList.push({
							'ruleName': '临时车商家停车减免收费规则',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 0,
							'parkId': this.parkId
						})
					}
					if (a == 'temppayStandardGzh') {
						parkRuleList.push({
							'ruleName': '临时车公众号优惠收费规则',
							'ruleKey': a,
							'ruleValue': this.parkRuleForm[a],
							'ruleType': 0,
							'parkId': this.parkId
						})
					}
				}

				var loading = this.$loading()
				this.$postJson(`/carCommonRule/` + this.parkId, parkRuleList)
					.then(res => {
							loading.close()
							this.parkRuleDialog = false
							this.$message.success(this.$i18n.t('lang.lab_save_success'))
							this.title = ''
							this.isShowForm = false
						},
						err => {
							loading.close()
							this.$message.error(err)
						})
			},
			changeCostHour() {
				let loading = this.$loading()
				if (this.parkRuleForm.temppayStandard === 1) {
					this.costHourForm.costName = ''
					this.costHourForm.cost1 = 0
					this.costHourForm.cost2 = 0
					this.costHourForm.cost3 = 0
					this.costHourForm.cost4 = 0
					this.costHourForm.cost5 = 0
					this.costHourForm.cost6 = 0	
					this.costHourForm.cost7 = 0				
					this.$get(`/carTempCostHour/` + this.parkId).then(
						res => {
						loading.close()
							if (res && res.errCode === 0) {
								this.innerCostHour = true
								this.costHourForm.costName = res.carTempCostHour.costName
								this.costHourForm.cost1 = res.carTempCostHour.cost1
								this.costHourForm.cost2 = res.carTempCostHour.cost2
								this.costHourForm.cost3 = res.carTempCostHour.cost3
								this.costHourForm.cost4 = res.carTempCostHour.cost4
								this.costHourForm.cost5 = res.carTempCostHour.cost5
								this.costHourForm.cost6 = res.carTempCostHour.cost6
								this.costHourForm.cost7 = res.carTempCostHour.cost7
							}					
						},
						error => {
							loading.close()
							this.$message.error(error)
						}
					)
				} else if (this.parkRuleForm.temppayStandard === 2) {
					this.costCountForm.costName = ''
					this.costCountForm.cost1 = 0
					this.costCountForm.cost2 = 0
					this.costCountForm.cost5 = 0
					this.$get(`/carTempCostCount/` + this.parkId).then(
						res => {
							loading.close()
							if (res && res.errCode === 0) {
								this.innerCostCount = true
								this.costCountForm.costName = res.carTempCostCount.costName
								this.costCountForm.cost1 = res.carTempCostCount.cost1
								this.costCountForm.cost2 = res.carTempCostCount.cost2								
								this.costCountForm.cost5 = res.carTempCostCount.cost5
							}					
						},
						error => {
							loading.close()
							this.$message.error(error)
						}
					)
				}
			},
			changeStoreCount() {	
				this.storeCountForm.costName = ''
				this.storeCountForm.cost2 = 0	
				this.storeCountForm.cost1 = 0					
				if (this.parkRuleForm.storePayStandard === 1) {
					let loading = this.$loading()
					this.$get(`/carStoreCount/` + this.parkId).then(
						res => {
						loading.close()
							if (res && res.errCode === 0) {
								this.innerStoreCount = true
								this.storeCountForm.costName = res.carStoreCount.costName
								this.storeCountForm.cost2 = res.carStoreCount.cost2
								this.storeCountForm.cost1 = res.carStoreCount.cost1
							}					
						},
						error => {
							loading.close()
							this.$message.error(error)
						}
					)
				} else if (this.parkRuleForm.storePayStandard === 2) {
					let loading = this.$loading()
					this.$get(`/carStoreCountUn/` + this.parkId).then(
						res => {
						loading.close()
							if (res && res.errCode === 0) {
								this.innerStoreCount = true
								this.storeCountForm.costName = res.carStoreCountUn.costName
								this.storeCountForm.cost2 = res.carStoreCountUn.cost2
								this.storeCountForm.cost1 = res.carStoreCountUn.cost1
							}					
						},
						error => {
							loading.close()
							this.$message.error(error)
						}
					)
				} else if (this.parkRuleForm.storePayStandard === 3) {
					let loading = this.$loading()
					this.$get(`/carStoreCostHour/` + this.parkId).then(
						res => {
						loading.close()
							if (res && res.errCode === 0) {
								this.innerStoreCostHour = true
								this.storeCostHourForm.costName = res.carStoreCostHour.costName
								this.storeCostHourForm.cost2 = res.carStoreCostHour.cost2
								this.storeCostHourForm.cost1 = res.carStoreCostHour.cost1
								this.storeCostHourForm.cost3 = res.carStoreCostHour.cost3
								this.storeCostHourForm.cost4 = res.carStoreCostHour.cost4
								this.storeCostHourForm.cost5 = res.carStoreCostHour.cost5
							}					
						},
						error => {
							loading.close()
							this.$message.error(error)
						}
					)
				}
			},
			changeCostHourDiscount() {	
				this.costHourDiscountForm.costName = ''
				this.costHourDiscountForm.cost1 = 0
				this.costHourDiscountForm.cost2 = 0
				this.costHourDiscountForm.cost3 = 0
				this.costHourDiscountForm.cost4 = 0
				this.costHourDiscountForm.cost5 = 0	
				if (this.parkRuleForm.temppayStandardDiscount === 1) {
					let loading = this.$loading()
					this.$get(`/carTempCostHourDiscount/` + this.parkId).then(
						res => {
						loading.close()
							if (res && res.errCode === 0) {
								this.innerCostHourDiscount = true
								this.costHourDiscountForm.costName = res.carTempCostHourDiscount.costName
								this.costHourDiscountForm.cost1 = res.carTempCostHourDiscount.cost1
								this.costHourDiscountForm.cost2 = res.carTempCostHourDiscount.cost2
								this.costHourDiscountForm.cost3 = res.carTempCostHourDiscount.cost3
								this.costHourDiscountForm.cost4 = res.carTempCostHourDiscount.cost4
								this.costHourDiscountForm.cost5 = res.carTempCostHourDiscount.cost5
							}					
						},
						error => {
							loading.close()
							this.$message.error(error)
						}
					)
				}
			},
			changeCostHourDerate() {	
				if (this.parkRuleForm.temppayStandardDerate === 1) {
					this.costHourDerateForm.keyword = ''
					this.costHourDerateForm.costName = ''
					this.costHourDerateForm.adminId = ''
					this.costHourDerateForm.adminName = ''
					this.costHourDerateForm.cost1 = 0
					this.costHourDerateForm.cost2 = 0
					this.costHourDerateForm.cost3 = 0
					this.costHourDerateForm.cost4 = 0
					this.costHourDerateForm.cost5 = 0
					this.costHourDerateForm.cost6 = 0	
					this.costHourDerateForm.cost7 = 0	
					this.costHourDerateForm.isUseCountMonth = 0
					this.innerCostHourDerate = true							
				}
			},
			searchStaff() {
				if (this.costHourDerateForm.keyword == '') {
					this.$message.error('请输入完整手机号或商户名')					
				} else {
					let loading = this.$loading()
					this.$get(`/carTempCostHourDerateByStaff?gardenId=${this.gardenId}&parkId=${this.parkId}&keyword=${this.costHourDerateForm.keyword}`).then(
						res => {
						loading.close()
							if (res && res.errCode === 0) {
								console.log(res)
								this.costHourDerateForm.costName = res.carTempCostHourDerate.costName
								this.costHourDerateForm.adminId = res.carTempCostHourDerate.adminId
								this.costHourDerateForm.adminName = res.carTempCostHourDerate.adminName
								this.costHourDerateForm.cost1 = res.carTempCostHourDerate.cost1
								this.costHourDerateForm.cost2 = res.carTempCostHourDerate.cost2
								this.costHourDerateForm.cost3 = res.carTempCostHourDerate.cost3
								this.costHourDerateForm.cost4 = res.carTempCostHourDerate.cost4
								this.costHourDerateForm.cost5 = res.carTempCostHourDerate.cost5
								this.costHourDerateForm.cost6 = res.carTempCostHourDerate.cost6
								this.costHourDerateForm.cost7 = res.carTempCostHourDerate.cost7
								this.costHourDerateForm.isUseCountMonth = res.isUseCountMonth
							}					
						},
						error => {
							loading.close()
							this.$message.error(error)
						}
					)
				}
			},
			changeCostHourGzh() {	
				this.costHourGzhForm.costName = ''
				this.costHourGzhForm.cost1 = 0
				this.costHourGzhForm.cost6 = 0
				this.costHourGzhForm.cost7 = 0
				this.costHourGzhForm.cost2 = 0
				this.costHourGzhForm.cost3 = 0
				this.costHourGzhForm.cost4 = 0
				this.costHourGzhForm.cost5 = 0	
				if (this.parkRuleForm.temppayStandardGzh === 1) {
					let loading = this.$loading()
					this.$get(`/carTempCostHourGzh/` + this.parkId).then(
						res => {
						loading.close()
							if (res && res.errCode === 0) {
								this.innerCostHourGzh = true
								this.costHourGzhForm.costName = res.carTempCostHourGzh.costName
								this.costHourGzhForm.cost1 = res.carTempCostHourGzh.cost1
								this.costHourGzhForm.cost6 = res.carTempCostHourGzh.cost6
								this.costHourGzhForm.cost7 = res.carTempCostHourGzh.cost7
								this.costHourGzhForm.cost2 = res.carTempCostHourGzh.cost2
								this.costHourGzhForm.cost3 = res.carTempCostHourGzh.cost3
								this.costHourGzhForm.cost4 = res.carTempCostHourGzh.cost4
								this.costHourGzhForm.cost5 = res.carTempCostHourGzh.cost5
							}					
						},
						error => {
							loading.close()
							this.$message.error(error)
						}
					)
				}
			},
			changeTempCheckGate() {
				this.gates = []
				this.gateList = []
				if (this.parkRuleForm.tempCheckGate === 1) {
					let loading = this.$loading()
					this.$get(`/carGateByPark/` + this.parkId).then(
						res => {
						loading.close()
							if (res && res.errCode === 0) {
								if (res.list.length > 0) {
									this.innerTempCheckGate = true
									for (var i = 0; i < res.list.length; i++) {
										this.gates.push({
											'id': res.list[i].id,
											'value': res.list[i].id,
											'name': res.list[i].gateName,
										})
									}
									if (res.gatesList.length > 0) {
										for (var a = 0; a < res.gatesList.length; a++) {
											this.$set(this.gateList, a, parseInt(res.gatesList[a]))
										}
									}
								}
							}					
						},
						error => {
							loading.close()
							this.$message.error(error)
						}
					)
				}
			},
			changeTiming() {	
				this.timingForm.costName = ''
				this.timingForm.cost1 = 0
				this.timingForm.cost2 = 0
				if (this.parkRuleForm.tempTiming === 1) {
					let loading = this.$loading()
					this.$get(`/carTempTiming/` + this.parkId).then(
						res => {
						loading.close()
							if (res && res.errCode === 0) {
								this.innerTiming = true
								this.timingForm.costName = res.carTempTiming.costName
								this.timingForm.cost1 = res.carTempTiming.cost1
								this.timingForm.cost2 = res.carTempTiming.cost2
							}					
						},
						error => {
							loading.close()
							this.$message.error(error)
						}
					)
				}
			},
			saveStoreCount(storeCountForm) {
				if (this.parkRuleForm.storePayStandard === 1) {
					this.$refs[storeCountForm].validate((valid) => {
						if (valid) {
							let loading = this.$loading()
							let params = {}
							params = {
									parkId: this.parkId,
									costName: this.storeCountForm.costName,
									cost2: this.storeCountForm.cost2,
									cost1: this.storeCountForm.cost1
								}
							
							this.$patch(`/carStoreCountByParkId`, params).then(
								res => {
									loading.close()
									if (res && res.errCode === 0) {
										this.$message.success(this.$i18n.t('lang.lab_save_success'))
										this.innerStoreCount = false
									}
									setTimeout(() => {
										loading.close()
									}, 200)
								},
								error => {
									loading.close()
									this.$message.error(error)
								}
							)
						} else {
							return false
						}
					})
				} else if (this.parkRuleForm.storePayStandard === 2) {
					this.$refs[storeCountForm].validate((valid) => {
						if (valid) {
							let loading = this.$loading()
							let params = {}
							params = {
									parkId: this.parkId,
									costName: this.storeCountForm.costName,
									cost2: this.storeCountForm.cost2,
									cost1: this.storeCountForm.cost1
								}
							
							this.$patch(`/carStoreCountUnByParkId`, params).then(
								res => {
									loading.close()
									if (res && res.errCode === 0) {
										this.$message.success(this.$i18n.t('lang.lab_save_success'))
										this.innerStoreCount = false
									}
									setTimeout(() => {
										loading.close()
									}, 200)
								},
								error => {
									loading.close()
									this.$message.error(error)
								}
							)
						} else {
							return false
						}
					})
				}
			},
			saveCostHour(costHourForm) {
				if (this.parkRuleForm.temppayStandard === 1) {
					this.$refs[costHourForm].validate((valid) => {
						if (valid) {
							let loading = this.$loading()
							let params = {}
							if (this.costHourForm.cost3 === 1) {
								params = {
									parkId: this.parkId,
									costName: this.costHourForm.costName,
									cost1: this.costHourForm.cost1,
									cost2: this.costHourForm.cost2,
									cost3: this.costHourForm.cost3,
									cost4: this.costHourForm.cost4,
									cost5: this.costHourForm.cost5,
									cost6: this.costHourForm.cost6,
									cost7: this.costHourForm.cost7
								}
							} else {
								params = {
									parkId: this.parkId,
									costName: this.costHourForm.costName,
									cost1: this.costHourForm.cost1,
									cost2: this.costHourForm.cost2,
									cost3: this.costHourForm.cost3,
									cost4: 0,
									cost5: this.costHourForm.cost5,
									cost6: this.costHourForm.cost6,
									cost7: this.costHourForm.cost7
								}
							}
							
							this.$patch(`/carTempCostHourByParkId`, params).then(
								res => {
									loading.close()
									if (res && res.errCode === 0) {
										this.$message.success(this.$i18n.t('lang.lab_save_success'))
										this.innerCostHour = false
									}
									setTimeout(() => {
										loading.close()
									}, 200)
								},
								error => {
									loading.close()
									this.$message.error(error)
								}
							)
						} else {
							return false
						}
					})
				}
			},
			saveCostCount(costCountForm) {
				if (this.parkRuleForm.temppayStandard === 2) {
					this.$refs[costCountForm].validate((valid) => {
						if (valid) {
							let loading = this.$loading()
							let params = {}
							params = {
									parkId: this.parkId,
									costName: this.costCountForm.costName,
									cost1: this.costCountForm.cost1,
									cost2: this.costCountForm.cost2,
									cost5: this.costCountForm.cost5
								}						
							
							this.$patch(`/carTempCostCountByParkId`, params).then(
								res => {
									loading.close()
									if (res && res.errCode === 0) {
										this.$message.success(this.$i18n.t('lang.lab_save_success'))
										this.innerCostCount = false
									}
									setTimeout(() => {
										loading.close()
									}, 200)
								},
								error => {
									loading.close()
									this.$message.error(error)
								}
							)
						} else {
							return false
						}
					})
				}
			},
			saveStoreCostHour(storeCostHourForm) {
				if (this.parkRuleForm.storePayStandard === 3) {
					this.$refs[storeCostHourForm].validate((valid) => {
						if (valid) {
							let loading = this.$loading()
							let params = {}
							if (this.storeCostHourForm.cost3 === 1) {
								params = {
									parkId: this.parkId,
									costName: this.storeCostHourForm.costName,
									cost1: this.storeCostHourForm.cost1,
									cost2: this.storeCostHourForm.cost2,
									cost3: this.storeCostHourForm.cost3,
									cost4: this.storeCostHourForm.cost4,
									cost5: this.storeCostHourForm.cost5
								}
							} else {
								params = {
									parkId: this.parkId,
									costName: this.storeCostHourForm.costName,
									cost1: this.storeCostHourForm.cost1,
									cost2: this.storeCostHourForm.cost2,
									cost3: this.storeCostHourForm.cost3,
									cost4: 0,
									cost5: this.storeCostHourForm.cost5
								}
							}
							
							this.$patch(`/carStoreCostHourByParkId`, params).then(
								res => {
									loading.close()
									if (res && res.errCode === 0) {
										this.$message.success(this.$i18n.t('lang.lab_save_success'))
										this.innerCostHour = false
									}
									setTimeout(() => {
										loading.close()
									}, 200)
								},
								error => {
									loading.close()
									this.$message.error(error)
								}
							)
						} else {
							return false
						}
					})
				}
			},
			saveCostHourDiscount(costHourDiscountForm) {
				if (this.parkRuleForm.temppayStandardDiscount === 1) {
					this.$refs[costHourDiscountForm].validate((valid) => {
						if (valid) {
							let loading = this.$loading()
							let params = {}
							if (this.costHourDiscountForm.cost3 === 1) {
								params = {
									parkId: this.parkId,
									costName: this.costHourDiscountForm.costName,
									cost1: this.costHourDiscountForm.cost1,
									cost2: this.costHourDiscountForm.cost2,
									cost3: this.costHourDiscountForm.cost3,
									cost4: this.costHourDiscountForm.cost4,
									cost5: this.costHourDiscountForm.cost5
								}
							} else {
								params = {
									parkId: this.parkId,
									costName: this.costHourDiscountForm.costName,
									cost1: this.costHourDiscountForm.cost1,
									cost2: this.costHourDiscountForm.cost2,
									cost3: this.costHourDiscountForm.cost3,
									cost4: 0,
									cost5: this.costHourDiscountForm.cost5
								}
							}
							
							this.$patch(`/carTempCostHourDiscountByParkId`, params).then(
								res => {
									loading.close()
									if (res && res.errCode === 0) {
										this.$message.success(this.$i18n.t('lang.lab_save_success'))
										this.innerCostHourDiscount = false
									}
									setTimeout(() => {
										loading.close()
									}, 200)
								},
								error => {
									loading.close()
									this.$message.error(error)
								}
							)
						} else {
							return false
						}
					})
				}
			},
			saveCostHourDerate(costHourDerateForm) {
				if (this.parkRuleForm.temppayStandardDerate === 1) {
					this.$refs[costHourDerateForm].validate((valid) => {
						if (valid) {
							let loading = this.$loading()
							let params = {}
							if (this.costHourDerateForm.cost3 === 1) {
								params = {
									parkId: this.parkId,
									costName: this.costHourDerateForm.costName,
									cost1: this.costHourDerateForm.cost1,
									cost2: this.costHourDerateForm.cost2,
									cost3: this.costHourDerateForm.cost3,
									cost4: this.costHourDerateForm.cost4,
									cost5: this.costHourDerateForm.cost5,
									cost6: this.costHourDerateForm.cost6,
									cost7: this.costHourDerateForm.cost7,
									adminId: this.costHourDerateForm.adminId
								}
							} else {
								params = {
									parkId: this.parkId,
									costName: this.costHourDerateForm.costName,
									cost1: this.costHourDerateForm.cost1,
									cost2: this.costHourDerateForm.cost2,
									cost3: this.costHourDerateForm.cost3,
									cost4: 0,
									cost5: this.costHourDerateForm.cost5,
									cost6: this.costHourDerateForm.cost6,
									cost7: this.costHourDerateForm.cost7,
									adminId: this.costHourDerateForm.adminId
								}
							}
							
							this.$patch(`/carTempCostHourDerateByParkId`, params).then(
								res => {
									loading.close()
									if (res && res.errCode === 0) {
										this.$message.success(this.$i18n.t('lang.lab_save_success'))
										this.innerCostHourDerate = false
									}
									setTimeout(() => {
										loading.close()
									}, 200)
								},
								error => {
									loading.close()
									this.$message.error(error)
								}
							)
						} else {
							return false
						}
					})
				}
			},
			saveTiming(timingForm) {
				console.log(this.timingForm.cost1)
				if (this.parkRuleForm.tempTiming === 1) {
					this.$refs[timingForm].validate((valid) => {
						if (valid) {
							let loading = this.$loading()
							let params = {}
							params = {
									parkId: this.parkId,
									costName: this.timingForm.costName,
									cost1: this.timingForm.cost1,
									cost2: this.timingForm.cost2
							}						
							
							this.$patch(`/carTempTimingByParkId`, params).then(
								res => {
									loading.close()
									if (res && res.errCode === 0) {
										this.$message.success(this.$i18n.t('lang.lab_save_success'))
										this.innerTiming = false
									}
									setTimeout(() => {
										loading.close()
									}, 200)
								},
								error => {
									loading.close()
									this.$message.error(error)
								}
							)
						} else {
							return false
						}
					})
				}
			},
			saveTempCheckGate(tempCheckGateForm) {
				if (this.gateList.length > 0) {
					if (this.parkRuleForm.tempCheckGate === 1) {
						let loading = this.$loading()
						let params = {}
						params = {
							parkId: this.parkId,
							gates: this.gateList.join(',')
						}
						this.$post(`/carTempGates`, params).then(
								res => {
									loading.close()
									if (res && res.errCode === 0) {
										this.$message.success(this.$i18n.t('lang.lab_save_success'))
										this.innerTempCheckGate = false
									}
									setTimeout(() => {
										loading.close()
									}, 200)
								},
								error => {
									loading.close()
									this.$message.error(error)
								}
							)
					}	
				} else {
					this.$message.error('请至少选择一个出入口')
				}
			},
			saveCostHourGzh(costHourGzhForm) {
				if (this.parkRuleForm.temppayStandardGzh === 1) {
					this.$refs[costHourGzhForm].validate((valid) => {
						if (valid) {
							let loading = this.$loading()
							let params = {}
							if (this.costHourGzhForm.cost3 === 1) {
								params = {
									parkId: this.parkId,
									costName: this.costHourGzhForm.costName,
									cost1: this.costHourGzhForm.cost1,
									cost6: this.costHourGzhForm.cost6,
									cost7: this.costHourGzhForm.cost7,
									cost2: this.costHourGzhForm.cost2,
									cost3: this.costHourGzhForm.cost3,
									cost4: this.costHourGzhForm.cost4,
									cost5: this.costHourGzhForm.cost5
								}
							} else {
								params = {
									parkId: this.parkId,
									costName: this.costHourGzhForm.costName,
									cost1: this.costHourGzhForm.cost1,
									cost6: this.costHourGzhForm.cost6,
									cost7: this.costHourGzhForm.cost7,
									cost2: this.costHourGzhForm.cost2,
									cost3: this.costHourGzhForm.cost3,
									cost4: 0,
									cost5: this.costHourGzhForm.cost5
								}
							}
							
							this.$patch(`/carTempCostHourGzhByParkId`, params).then(
								res => {
									loading.close()
									if (res && res.errCode === 0) {
										this.$message.success(this.$i18n.t('lang.lab_save_success'))
										this.innerCostHourGzh = false
									}
									setTimeout(() => {
										loading.close()
									}, 200)
								},
								error => {
									loading.close()
									this.$message.error(error)
								}
							)
						} else {
							return false
						}
					})
				}
			},
			saveCarWxpay(carWxpayForm) {
				this.$refs[carWxpayForm].validate((valid) => {
					if (valid) {
						let loading = this.$loading()
						let params = {}
						params = {
							parkId: this.parkId,
							gardenId: this.gardenId,
							appId: this.carWxpayForm.appId,
							mchId: this.carWxpayForm.mchId,
							mchKey: this.carWxpayForm.mchKey
						}

						this.$post(`/carWxpay`, params).then(
								res => {
									loading.close()
									if (res && res.errCode === 0) {
										this.$message.success(this.$i18n.t('lang.lab_save_success'))
										this.carWxpayDialog = false
									}
									setTimeout(() => {
										loading.close()
									}, 200)
								},
								error => {
									loading.close()
									this.$message.error(error)
								}
							)

					}
				})
			}		
		},

	}
</script>

<style lang='scss'>
	.menuManagementList {
		.location {
			padding: 40px;
		}

		.form-padding {
			padding-top: 20px;
		}

		.divL {
			width: 40%;
			float: left;
		}

		.divR {
			width: 60%;
			float: right;
		}

		.inputkey {
			width: 60%;
		}

		.input-width {
			width: 50%;
		}

		.divDialogL {
			width: 48%;
			display: inline-block;
		}

		.divDialogR {
			width: 50%;
			float: right;
			display: inline-block;

			border-left-style: solid;
			border-left-width: 1px;
			border-left-color: #DCDFE6;
		}

		.el-dialog .el-form .el-form-item {
			margin-right: 0;
			margin-top: 10px;
			margin-bottom: 0;
			text-align: left;
		}

		.el-dialog .el-form .el-select.aaa {
			width: 200px;
		}

		.detailbtn {
			width: auto;
			min-width: 120px;
		}
	}
</style>